webpackJsonp([2],{

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ContentLoader_vue_vue_type_template_id_4f47de90___ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContentLoader_vue_vue_type_script_lang_js___ = __webpack_require__(288);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ContentLoader_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__ContentLoader_vue_vue_type_template_id_4f47de90___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ContentLoader_vue_vue_type_template_id_4f47de90___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dish_vue_vue_type_template_id_af6ec360___ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dish_vue_vue_type_script_lang_js___ = __webpack_require__(293);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Dish_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Dish_vue_vue_type_template_id_af6ec360___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Dish_vue_vue_type_template_id_af6ec360___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie__);



var configDev = __webpack_require__(817);
var configProd = __webpack_require__(345);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

// по усполчанию смотрим в куки и загружаем конфиг для стэйджа
var API_ROOT = __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get('API_ROOT') ? __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get('API_ROOT') : configDev.API_ROOT;

if (true) {
  // если билд для прода то смотрим в куки или в конфиг для прода
  API_ROOT = __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get('API_ROOT') ? __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get('API_ROOT') : configProd.API_ROOT;
}

var JSON_API_ROOT = API_ROOT + '/wp-json/wp/v2';

var apis = {
  loadCategories: function loadCategories() {
    // let path = `${JSON_API_ROOT}/category?orderby=menu_order&order=asc&per_page=100`
    // if (Cookies.get('new_test')) {
    // }
    var path = 'https://menu.xochu-shashlik.ru/wp-content/themes/welbempty/mangalGrillSite.php';

    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(path);
    // return Vue.http.get(`${JSON_API_ROOT}/category?orderby=menu_order&order=asc&per_page=100`)
  },
  loadRestaurants: function loadRestaurants() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(JSON_API_ROOT + '/restaurant?orderby=menu_order&order=asc&per_page=100');
  },
  loadPromotions: function loadPromotions() {
    // let path = `${JSON_API_ROOT}/promotion?orderby=menu_order&order=asc&per_page=100`
    // if (Cookies.get('new_test')) {
    // }
    var path = API_ROOT + '/wp-content/themes/welbempty/promotions.php';
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get(path);
    // return Vue.http.get(`${JSON_API_ROOT}/promotion?orderby=menu_order&order=asc&per_page=100`)
  },
  createOrder: function createOrder(payload) {
    // let path = `${API_ROOT}/wp-content/themes/welbempty/saveOrder.php`
    // if (Cookies.get('new_test')) {
    // }
    var path = 'https://menu.xochu-shashlik.ru/wp-content/themes/welbempty/createOrder.php';
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(path, payload);
    // return Vue.http.post(`${API_ROOT}/wp-content/themes/welbempty/saveOrder.php`, payload)
  },
  reserveTable: function reserveTable(payload) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post(API_ROOT + '/wp-content/themes/welbempty/reserveTable.php', payload);
  }
};
var api = apis;


// Доступ к апишкам для дев-режима
if (false) {
  window.apis = apis;
}

/***/ }),

/***/ 138:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Phone_vue_vue_type_template_id_22e63874___ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Phone_vue_vue_type_script_lang_js___ = __webpack_require__(314);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Phone_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Phone_vue_vue_type_template_id_22e63874___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Phone_vue_vue_type_template_id_22e63874___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 193:
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"30\" height=\"34\" viewBox=\"0 0 30 34\"><g fill=\"#F54A0B\" fill-rule=\"nonzero\"><path d=\"M13.966 18.989v14.855c-3.518 0-6.983.105-10.397-.105-1.5 0-1.759-.994-1.759-2.04-.051-4.184 0-8.369 0-12.71h12.156zM15.983 33.949v-14.96h12.103v12.763c0 1.517-1.19 2.197-2.586 2.197h-9.517zM14.948 5.702c1.138-1.412 2.07-2.772 3.207-4.027C19.76-.104 21.828-.418 23.638.629c1.707.993 2.638 3.033 2.172 4.916-.569 2.145-2.069 3.348-4.5 3.4-4.293.053-8.586.053-12.879 0-2.38-.052-3.828-1.255-4.345-3.504-.414-1.83.414-3.766 2.07-4.76 1.81-1.099 3.723-.89 5.378.784 1.19 1.308 2.225 2.773 3.414 4.237zm-1.345 1.413c-1.344-1.726-2.172-3.191-3.413-4.237-.724-.576-2.173-.89-3-.523-.724.314-1.604 1.36-1.345 2.667C6 5.912 7.24 6.75 8.12 6.958c1.603.418 3.258.157 5.482.157zm2.69.052c2.276.105 3.931.21 5.431-.157 1.604-.366 2.173-1.412 2.328-2.354.103-.68-.414-1.935-1.293-2.301-.828-.366-2.276-.105-2.949.47-1.293.994-2.534 3.087-3.517 4.342zM13.966 10.933v6.016H4.138c-3.207 0-4.138.366-4.138-3.4 0-1.099.207-2.564 2.172-2.616 3.828-.104 7.656 0 11.794 0zM15.983 16.949v-6.016c4.138 0 8.172-.052 12.207.052 1.551.105 1.344 2.093 1.344 2.197 0 4.237-.465 3.819-4.034 3.767h-9.517z\"></path></g></svg>"

/***/ }),

/***/ 195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__QuantitySelector_vue_vue_type_template_id_43d55a60___ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__QuantitySelector_vue_vue_type_script_lang_js___ = __webpack_require__(295);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__QuantitySelector_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__QuantitySelector_vue_vue_type_template_id_43d55a60___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__QuantitySelector_vue_vue_type_template_id_43d55a60___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return numberLingFormFunc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return numberLingFormWithNumberFunc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return moneyFormatFunc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deliveryZones; });
function numberLingFormFunc(number, chelovek, cheloveka, chelovekov) {
  if (number % 10 === 1 && number % 100 !== 11) {
    return chelovek;
  }

  if ((number % 10 === 2 || number % 10 === 3 || number % 10 === 4) && (number % 100 < 10 || number % 100 > 20)) {
    return cheloveka;
  }

  return chelovekov;
}

function numberLingFormWithNumberFunc(number, chelovek, cheloveka, chelovekov) {
  return number + ' ' + numberLingFormFunc(number, chelovek, cheloveka, chelovekov);
}

function moneyFormatFunc(number) {
  if (!number && number !== 0) return;
  return Math.round(number).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,').replace(/,/g, ' ');
}

var coords800 = [[30.20802935098665, 59.90525378432682], [30.20670658637305, 59.90625058810715], [30.205498721177836, 59.90822255197936], [30.20577140690088, 59.909982430410096], [30.207996295948114, 59.91309288232892], [30.209370088718373, 59.91927721390966], [30.211013762701683, 59.927118680952496], [30.210248265078768, 59.92814175191275], [30.20177946316506, 59.928453963909604], [30.19078331992693, 59.93150167151554], [30.176377340128703, 59.944292982982255], [30.182367998002437, 59.94818161875574], [30.183165899223418, 59.95506164556807], [30.199271846246745, 59.953185541535845], [30.207517938807488, 59.95942524049184], [30.211472496944413, 59.96579285766924], [30.207966131650846, 59.97688977319175], [30.185748676269444, 59.9833382729246], [30.18287334820549, 59.99038030627761], [30.188838581054608, 59.99479828024423], [30.19398842236321, 60.00500787733098], [30.20411644360338, 60.01265762908531], [30.224458316772303, 60.009907360964604], [30.231238941161994, 60.01145441502962], [30.239392856567207, 60.01368892044295], [30.251494983642417, 60.0172122557538], [30.266000369994956, 60.02150849625134], [30.275098422973475, 60.024214840067714], [30.27911100765974, 60.02372084150291], [30.282630065887293, 60.02320535684968], [30.285129884689173, 60.0228724353857], [30.28691623589308, 60.02291002345868], [30.291993657558272, 60.02359465589332], [30.2970281638792, 60.024268535107446], [30.307692626922446, 60.02565383710272], [30.30975256344588, 60.02593303819253], [30.31104002377303, 60.02627666707393], [30.315586869960175, 60.028323085167585], [30.319747478049162, 60.03004726417248], [30.333994013159902, 60.03075985480491], [30.349486452429908, 60.03150102455955], [30.357980602718136, 60.031913973860505], [30.361948728124677, 60.03214191944343], [30.36520875035132, 60.03204777109814], [30.371551079619582, 60.031371539492106], [30.375930739024277, 60.03046466808802], [30.4064835917922, 60.0219805770602], [30.433367879151312, 60.015235294045674], [30.435513446349155, 60.00726697797453], [30.43631342285443, 60.00369690992568], [30.43715213183048, 60.00024967518073], [30.438141044511397, 59.99603896630843], [30.439249192012678, 59.99371951769627], [30.441160374434766, 59.99083550084661], [30.442081986109248, 59.990692823218396], [30.442231121587447, 59.990388894692124], [30.44658217261085, 59.989826270586235], [30.45074253279354, 59.98948876377589], [30.453777579294208, 59.98923553169633], [30.455274332139908, 59.98901330037314], [30.456725447324626, 59.9886441704121], [30.457919070443996, 59.98804927013898], [30.458501733774387, 59.98742959079882], [30.45884621893575, 59.98616019612443], [30.45848452012061, 59.98048758126637], [30.458218607975816, 59.97729101611697], [30.457926115091738, 59.97297967367419], [30.45759125760094, 59.9693024729568], [30.457394732353137, 59.965863998273775], [30.457873437755413, 59.964860065673754], [30.46584687178683, 59.956899875081355], [30.471513109593864, 59.95146514352756], [30.475217667506858, 59.947759865909234], [30.47715592297204, 59.94590878462558], [30.478210881393057, 59.944961675396534], [30.478021294831233, 59.94401453903667], [30.472625318116826, 59.92665850439267], [30.47063029347264, 59.919865105498616], [30.439061276710564, 59.91232594873419], [30.437871129305012, 59.91278575162365], [30.428617884902135, 59.908195674046574], [30.423707509261604, 59.90273739225254], [30.41918337171918, 59.899132383667464], [30.413434853161128, 59.89778554750597], [30.410003763191934, 59.896438656564385], [30.4043839906666, 59.894102889792414], [30.403794862180774, 59.89399911108942], [30.4021757654333, 59.89460690224432], [30.39966713279037, 59.89504622045252], [30.397973891687986, 59.89538850401615], [30.394928817242114, 59.894846739734], [30.393376966003522, 59.8945933515795], [30.391438876666825, 59.89403808268566], [30.38768761403601, 59.892922155656564], [30.384622996913034, 59.89232373077899], [30.385249099394557, 59.89142339241904], [30.38458774154896, 59.890911200204854], [30.380541423766847, 59.889315121480934], [30.368650835936815, 59.88457475927594], [30.358715651687465, 59.88036333736982], [30.35692280243182, 59.87974453540648], [30.354142900258786, 59.87921201211887], [30.349055164699347, 59.87812536663655], [30.342765799501183, 59.87709262031215], [30.33647643430307, 59.87614614001502], [30.29488239666719, 59.875423739008326], [30.294640167972293, 59.87661775208403], [30.292938817573322, 59.87876093980926], [30.28887264745551, 59.880449178130384], [30.28027799051386, 59.88186670380475], [30.274993609125556, 59.88248916243948], [30.271211264785585, 59.8833704482155], [30.264801673872316, 59.88495951073495], [30.259152082428965, 59.88649889025408], [30.256026879297636, 59.887300904086985], [30.253674152362613, 59.88818916534894], [30.25184333723906, 59.889366777698214], [30.25027001418095, 59.891018778010675], [30.248353368368896, 59.892422711714055], [30.246093399802998, 59.89324437955497], [30.24464586619282, 59.89369649073183], [30.240709242616916, 59.89436422304152], [30.23818303135385, 59.89478058278103], [30.236386380942832, 59.89526162358824], [30.228602002920788, 59.8982032744338], [30.22508346403097, 59.8992038757236], [30.21786151997916, 59.90185985646503], [30.210038761108084, 59.90445095591026], [30.20802935098665, 59.90525378432682]];
var coords1200 = [[30.47481058546358, 59.93352089217349], [30.47597911658569, 59.93717449789039], [30.476671802123427, 59.93952708796038], [30.477597794688688, 59.94244471302486], [30.478251070167836, 59.944742398039466], [30.47822842897533, 59.94499466734686], [30.476045691307704, 59.947015063665866], [30.473889413493684, 59.94915642584748], [30.471793987597167, 59.95123505795278], [30.46981321961385, 59.9531729786743], [30.468157905215076, 59.95468159958018], [30.46670643870148, 59.956141726197636], [30.46367652300359, 59.959132667190985], [30.46186653874735, 59.96094168159208], [30.460016109695093, 59.962776822073394], [30.4579310304589, 59.964837584935545], [30.457426278188322, 59.965847162100225], [30.457605567636275, 59.968392336467815], [30.45778121658111, 59.9710348002239], [30.457935653032497, 59.972675611223075], [30.458125579510018, 59.974810826078226], [30.458273455705374, 59.97716905639996], [30.45842738674385, 59.979380346382605], [30.458606363945503, 59.98195439699686], [30.45878296529517, 59.984642486134646], [30.45886087206449, 59.986192631131296], [30.458482662966894, 59.987487368230674], [30.457903098183053, 59.9880385476035], [30.456744176251977, 59.988632720284244], [30.455477758323767, 59.98895025335537], [30.453821314137414, 59.98923802402747], [30.44911788051011, 59.989644045591014], [30.446715979134396, 59.98981624542024], [30.442269918814723, 59.99038878814549], [30.442065249879885, 59.990684761224976], [30.441238308453602, 59.99083023338528], [30.44044273248577, 59.99195965006223], [30.439415243972327, 59.993532428145144], [30.438182040943637, 59.99605734498178], [30.437529538127297, 59.99883733950952], [30.43692677220557, 60.00135748310415], [30.43643352291065, 60.00355909267873], [30.43600269327668, 60.00537708955596], [30.435498783291408, 60.00731216889683], [30.435054684296873, 60.00912307594825], [30.43459386103237, 60.01093631753928], [30.434112974162034, 60.01265130567457], [30.43343379927446, 60.0152559735816], [30.429795215291996, 60.0161482822472], [30.425932080031444, 60.017124917889234], [30.41967408593599, 60.01869428874453], [30.413118767103562, 60.02033180150721], [30.406762236547127, 60.021927827677686], [30.401778539793003, 60.023325227755535], [30.39740378068743, 60.02450167277285], [30.387298915212213, 60.027461137902826], [30.371426108487864, 60.031485309274274], [30.36362989014201, 60.03218829703468], [30.333211713392405, 60.03075693151291], [30.326892428953315, 60.03041797045346], [30.319724661656185, 60.03005259499939], [30.315529669958174, 60.02829962140336], [30.311160162045958, 60.02640196640137], [30.310506683096445, 60.0261559234635], [30.30968154277006, 60.02594209408726], [30.30636065625907, 60.0255092670792], [30.297280968385525, 60.024306317109776], [30.286846866405483, 60.0229016602388], [30.285123750873314, 60.0228601226613], [30.281136850932608, 60.02346294716265], [30.27513350518136, 60.0241995131987], [30.27321557127967, 60.02368244157624], [30.259232802488466, 60.01953534420585], [30.253984193929593, 60.017987847378386], [30.245505075168428, 60.01545560846848], [30.23908743552468, 60.01364798806749], [30.23130527906184, 60.011498914137206], [30.224490738879386, 60.0099261728151], [30.21197566680222, 60.0116031785446], [30.204243695950364, 60.01273132296966], [30.218973249889835, 60.02134339925849], [30.231170798519166, 60.026259438683894], [30.24410749886627, 60.02977644510067], [30.256543142094788, 60.033635337687684], [30.26710557149647, 60.036680512021285], [30.280714647392593, 60.036883527370506], [30.290587632453683, 60.03332424566053], [30.293422501059716, 60.03629215512406], [30.296297266779113, 60.03896342399268], [30.30264817538185, 60.036975877609834], [30.303183492495727, 60.037260015947616], [30.303890470986495, 60.037350927174984], [30.3059459087537, 60.037684246771384], [30.310887025439495, 60.03803340030392], [30.318059740025696, 60.03889779725296], [30.316698153206932, 60.04096999861106], [30.31500494783111, 60.04494229427372], [30.312949969275902, 60.047278965927234], [30.311324144163137, 60.05053830199738], [30.31317941990184, 60.05087591918], [30.33175022222138, 60.05357409538546], [30.33487150061513, 60.052924567840165], [30.338062190564248, 60.05671952927728], [30.341124134480634, 60.060814412648554], [30.357105545095063, 60.05741200928212], [30.376022000791515, 60.053444353893916], [30.382407175970418, 60.05252362062726], [30.401073934657553, 60.0486977499313], [30.414289028569833, 60.045955098095966], [30.431109418065642, 60.042397494160014], [30.432190677058593, 60.041754065407694], [30.432499459855283, 60.039865513478254], [30.432344549252324, 60.02925982299673], [30.437372632878965, 60.02915578829324], [30.437367781987852, 60.02242319181866], [30.438392899358444, 60.02065155598026], [30.456912924505104, 60.014036725946966], [30.478517471932, 59.9886156528059], [30.483653653244232, 59.98368762759725], [30.48405450225789, 59.98051916891779], [30.48361850205892, 59.97733965164624], [30.488953805941964, 59.97542162498909], [30.491803075161613, 59.97503778844242], [30.49112126954976, 59.9747863522687], [30.48588301280043, 59.971429479865286], [30.480001025887567, 59.97015911990755], [30.48422545987472, 59.966262089972794], [30.488771758943614, 59.961848155359895], [30.497245813564724, 59.953766897116765], [30.502923888759486, 59.94837343483618], [30.505031245682613, 59.946369854310646], [30.50550781952475, 59.94544263905392], [30.507810948608196, 59.94555146836178], [30.500928616886434, 59.91474901999228], [30.499549744842305, 59.910655567941966], [30.482785743585602, 59.90665693353437], [30.487927024489846, 59.90129359533489], [30.491577829822937, 59.89713869802638], [30.491865339886626, 59.89619200604319], [30.490264574803824, 59.88983276134693], [30.48912053653822, 59.88494281427012], [30.481890299239847, 59.88407445172522], [30.476548337088037, 59.88321685138377], [30.470030142237437, 59.88182509891344], [30.4664136705965, 59.88092381811524], [30.453263986772985, 59.877595871848584], [30.444756363602785, 59.87560284830274], [30.437192878005916, 59.87332921342613], [30.42481248884335, 59.869083584686024], [30.40800588708827, 59.863489937497164], [30.400425964412186, 59.861187576526426], [30.39258854967066, 59.85905774130882], [30.38538413625665, 59.85726619757195], [30.378737622317747, 59.85605742741659], [30.37181781787534, 59.854903224535676], [30.36309728922008, 59.85387411402327], [30.352302001624718, 59.85271087187375], [30.346956962747612, 59.85241119921256], [30.337470234877213, 59.852269071383915], [30.329998091392312, 59.852109154299214], [30.33010050616544, 59.851076029483764], [30.321590102376483, 59.851002071268745], [30.320761545206132, 59.85220195397488], [30.3057860533892, 59.85200827509842], [30.298172506431296, 59.85197807399932], [30.290412682412992, 59.851951807002884], [30.29017179126126, 59.85546833438979], [30.288943847192026, 59.85570330071488], [30.288907536897735, 59.85693618138253], [30.287927089030234, 59.85840646387904], [30.280880808768536, 59.86206911235927], [30.27706686280828, 59.863582081729334], [30.275055361306116, 59.8639295488053], [30.272373773327057, 59.86418002855434], [30.24208502705932, 59.86459988476679], [30.229299244839382, 59.86494608833542], [30.20315469546261, 59.87450456647381], [30.181959129872368, 59.8843801568738], [30.189936893628445, 59.892602326924916], [30.211557246580085, 59.90393206471255], [30.216447541906877, 59.90231039114299], [30.221152804718074, 59.90063788779151], [30.22285332523351, 59.9000165187036], [30.224625901915257, 59.8993719852363], [30.225103761265256, 59.899192409147894], [30.22582838384465, 59.89898588255349], [30.22687276396832, 59.89869031562734], [30.228094435911554, 59.89834489665753], [30.22858760852839, 59.89820438498322], [30.22913442532554, 59.89800188695628], [30.230183573045004, 59.89760514886505], [30.231181556795857, 59.897227339679475], [30.232168710711967, 59.89685606645728], [30.233159837442262, 59.89647336623842], [30.23426292114933, 59.89606215846515], [30.235328106029186, 59.895663847852475], [30.236139648206688, 59.89535049289506], [30.236420486097625, 59.89524813951758], [30.237334325316084, 59.894997545731215], [30.238175408320842, 59.89478338718663], [30.239301370794088, 59.89459223546858], [30.240363082463475, 59.89441693997587], [30.24162835755175, 59.89420395855436], [30.242917427982825, 59.89398522996834], [30.2442305105312, 59.89376414882309], [30.24464435756439, 59.893694042602284], [30.245773960982085, 59.89334506440622], [30.246303893973735, 59.89317036049821], [30.247529295550706, 59.892715372684904], [30.248295551633447, 59.892435988300775], [30.248351617465502, 59.892419714744705], [30.248799285813764, 59.892088067138495], [30.24961785012106, 59.89149790700959], [30.250259143354477, 59.89101989666439], [30.250834599827616, 59.890431028909006], [30.251389207861155, 59.88983071588243], [30.251851584299946, 59.88936590180245], [30.25276859516677, 59.88876813979401], [30.25368255788856, 59.88818406082169], [30.25473364854628, 59.88779005994005], [30.255791612364582, 59.887390234067645], [30.256031037674873, 59.88729645008739], [30.256882006640655, 59.8870786535226], [30.2580591154388, 59.88677323724395], [30.25933110587479, 59.886447114543934], [30.2608874459959, 59.88602213937208], [30.262280629041946, 59.88564480036297], [30.263528150372665, 59.88530221458929], [30.26480258085644, 59.88496054484615], [30.26596358023268, 59.884669871671036], [30.267553729577585, 59.88427219830659], [30.268620071664476, 59.88400754998979], [30.269504631758206, 59.88379143291665], [30.27043390481255, 59.88356223873287], [30.271498511245, 59.883300696672165], [30.272538860885504, 59.88306140088061], [30.27363408180106, 59.88280518872596], [30.27496515715972, 59.88249905345573], [30.27639811455547, 59.88232332550248], [30.277935141452296, 59.88214181932435], [30.28005615160958, 59.88188819414957], [30.280301305907397, 59.88186637573408], [30.281329665237553, 59.881693561295506], [30.282677671110445, 59.8814708629054], [30.283526239377014, 59.88133322333119], [30.28543594049922, 59.88101297210152], [30.287292162862393, 59.88071153646462], [30.288280106504324, 59.88054421929147], [30.288865604035667, 59.880444381599254], [30.292934020529763, 59.878756316857526], [30.29457498680039, 59.876666349363205], [30.294871900542148, 59.87540237689965], [30.29722875080734, 59.875449061962534], [30.301253609207148, 59.875529558782105], [30.305851687897366, 59.87562193840312], [30.31175332016889, 59.875701664691796], [30.316310393285164, 59.875773719952946], [30.32141061372693, 59.87586946232472], [30.3261333132499, 59.875986682945616], [30.329175944101188, 59.876020560424095], [30.332952416003412, 59.87609041398779], [30.33639633318312, 59.87615080127079], [30.339759245993903, 59.87664215383822], [30.341962408017093, 59.876968039750125], [30.344287076339494, 59.87733494226666], [30.34631576401247, 59.87767148932277], [30.348093349760546, 59.87796446009727], [30.3495973501891, 59.87823046184452], [30.351540457173517, 59.87866311638896], [30.35329253348905, 59.879029809620086], [30.355431892092835, 59.879459617860874], [30.35690390274695, 59.879747138177514], [30.358935415028146, 59.880446684911824], [30.360675367602727, 59.88118948820499], [30.362489481463275, 59.88194656806854], [30.364823473589432, 59.88294515586715], [30.367106268602704, 59.88391365355463], [30.36934200738745, 59.8848410578202], [30.371642730955354, 59.88575476833363], [30.373565568935632, 59.88653133308127], [30.3758037194168, 59.8874172307845], [30.37824512370172, 59.888390843106905], [30.380426056671528, 59.88925637146556], [30.3828254411557, 59.89021029888654], [30.38457304884926, 59.890889735440595], [30.385255671043563, 59.891411685078445], [30.3846260224773, 59.89231803817014], [30.38763847847709, 59.89291653746019], [30.38918108393676, 59.8933694739514], [30.391135073204083, 59.893948085551514], [30.39333850255765, 59.894587925199794], [30.39539776585277, 59.89493027361768], [30.397942508979607, 59.895370926207534], [30.399183030648988, 59.895148082928166], [30.401112209482946, 59.894794738105766], [30.40220554493261, 59.89459770812206], [30.403792909755225, 59.89400551789501], [30.404422977416587, 59.89414331502642], [30.406545820123345, 59.89498451602514], [30.408368988836944, 59.89575276648108], [30.410476838414382, 59.896616392870705], [30.413394898468457, 59.89776057573907], [30.41538179808129, 59.898241176278496], [30.417459892800625, 59.89873793971113], [30.419162368872193, 59.89912747887791], [30.420307219933584, 59.90000642548728], [30.421508945977365, 59.90097574736304], [30.422985227743478, 59.90215284671203], [30.423699545697676, 59.902725308403134], [30.424700117886065, 59.90382428839834], [30.425844134143833, 59.905093611376664], [30.426834566879005, 59.906208364494155], [30.42796814899214, 59.907459069353884], [30.428618088528165, 59.90819463996925], [30.43303342704379, 59.91037544203847], [30.437913130594218, 59.91278037496489], [30.43909770855049, 59.912312617986835], [30.440110625129797, 59.91255603877981], [30.45051917008897, 59.91505022203878], [30.46146258286969, 59.917658568663775], [30.470636116901094, 59.91985264323894], [30.473214943918986, 59.92839408423064], [30.474159081492218, 59.931409615627906], [30.47481058546358, 59.93352089217349]];
var coords1400 = [[30.249506220259754, 59.86443767027905], [30.258416518607223, 59.86432448526863], [30.26598303023824, 59.864222396140114], [30.27119120703208, 59.864163790676024], [30.272514708902605, 59.86413834811614], [30.273838210773206, 59.86400499359174], [30.275075881955285, 59.86388242977741], [30.276249180121074, 59.863695117693716], [30.27710502853019, 59.86351720608706], [30.280815976568924, 59.86209008911773], [30.28290748498163, 59.86097719861698], [30.285449604508862, 59.85976713756755], [30.28783352075515, 59.8583856411359], [30.288845210738373, 59.856995999862356], [30.288914510006222, 59.85570479889654], [30.290140287809685, 59.85545855981334], [30.29025598479707, 59.85370288995024], [30.290378206307103, 59.85216652758133], [30.290371681784507, 59.851947127143674], [30.294891260741185, 59.851951607575366], [30.300102849623755, 59.85197115011821], [30.305885692259825, 59.85198783192657], [30.310383756777757, 59.85204076651688], [30.31499849738785, 59.85212154603387], [30.31878907167837, 59.85216981252894], [30.32070319188648, 59.85218432889504], [30.321601243392195, 59.85099357566554], [30.325746918092598, 59.8510292856653], [30.330117898350267, 59.8510757910599], [30.330004680646603, 59.85209682224414], [30.33587278904616, 59.852232741932816], [30.341752191206808, 59.85233569357103], [30.34685107054408, 59.85238814146724], [30.35157846393283, 59.852646144924414], [30.352547411939426, 59.85270960513286], [30.356824529489792, 59.85317569873308], [30.360578136965234, 59.853595633263815], [30.364149354227703, 59.85397778183474], [30.36836006350776, 59.85447328869942], [30.373233457851157, 59.85511510333883], [30.378820319792492, 59.85605985960235], [30.385520630733268, 59.8572758163363], [30.38828338242941, 59.857973513916754], [30.391818610321835, 59.85885467647047], [30.396367483989486, 59.8600685528652], [30.400776959199092, 59.861290844663294], [30.409172197004906, 59.863846155655224], [30.41360588850652, 59.86532410307812], [30.416359176060286, 59.866253464604675], [30.421206598302412, 59.86784798651716], [30.424933863004714, 59.86911723997815], [30.428927169313695, 59.87047455174804], [30.43388498122059, 59.872164187605094], [30.438075136525523, 59.87359237584058], [30.442176506521164, 59.87479607762795], [30.444897743772675, 59.875621691800085], [30.4489942155936, 59.876566118675264], [30.45247665418461, 59.87737841686322], [30.4558625332511, 59.87821766162294], [30.45974983325608, 59.87922130364935], [30.464622455502802, 59.88044823311015], [30.468458879731983, 59.881415069323424], [30.470053669325793, 59.8818335175417], [30.47190595098505, 59.882219604656534], [30.475992875488302, 59.88306430815189], [30.47987865259851, 59.88371716793837], [30.482250694596047, 59.884099794673716], [30.486585213416333, 59.88462738375503], [30.489160203122918, 59.884912316172056], [30.48967922660889, 59.88704625475364], [30.490034265767093, 59.88868738167907], [30.490401065962356, 59.89033279703145], [30.49092338023279, 59.892373859910265], [30.491615089055287, 59.89518995985835], [30.491888373271447, 59.896210877754996], [30.49163647894906, 59.897112710571506], [30.490129170305867, 59.898836187634856], [30.4884594553336, 59.90071115869406], [30.486599990134735, 59.902699536033055], [30.48495072651761, 59.90441325123215], [30.482840122949934, 59.90665497093205], [30.48796476902591, 59.90788274484425], [30.494788308759812, 59.9094826685814], [30.497497387350148, 59.91013447802072], [30.499573464613015, 59.910619246497525], [30.500707802696414, 59.91414814954281], [30.501303363932905, 59.91622090337605], [30.501714361382863, 59.91809690969336], [30.502289529827387, 59.92059494389283], [30.502641011972774, 59.922173437332916], [30.50297268434894, 59.92359835753342], [30.503447859796093, 59.9258519637554], [30.50393029675354, 59.928112306769044], [30.50444327149334, 59.93027362885563], [30.504890681401662, 59.93228038218141], [30.50534670951379, 59.934357868879935], [30.505771083832304, 59.93629029228216], [30.506214972212312, 59.93831164596815], [30.50660587907447, 59.9400140287963], [30.50697679697684, 59.94158920523259], [30.507335240242696, 59.94332682387055], [30.507853394108555, 59.94552344825854], [30.50570483085665, 59.94558411945899], [30.480081574306475, 59.97014675463617], [30.485827508110837, 59.97142982545988], [30.491135920798566, 59.9747817467878], [30.49195968001345, 59.97508979405784], [30.488963973591, 59.97542472575441], [30.48369375392401, 59.97737283666104], [30.484127091203547, 59.98050832622977], [30.48374503694256, 59.98365427011145], [30.47862083714324, 59.98858456749577], [30.475126983134697, 59.99260782370658], [30.47111215741973, 59.99742055850988], [30.466678046336973, 60.002557584509304], [30.462551952867543, 60.007532643662245], [30.45899098510151, 60.011693172108224], [30.45703798055934, 60.01402196345849], [30.45178049451084, 60.015899440684564], [30.438392760937827, 60.020652216380476], [30.437403626475916, 60.02235557535231], [30.43740559416276, 60.025898870307664], [30.437429019521787, 60.029119663102584], [30.43236341249407, 60.029236222720954], [30.43250205492781, 60.03497330138458], [30.432467572252193, 60.038434092496594], [30.432261428199705, 60.041679854039025], [30.431128000891874, 60.042404433392555], [30.427891721716428, 60.043064599643785], [30.423533289728244, 60.044027657158196], [30.418895908002508, 60.04497995425504], [30.390530844349918, 60.050894749694045], [30.382221360821788, 60.05263173856591], [30.37627469400649, 60.0534482978356], [30.36719520706187, 60.05534847014796], [30.341078063324165, 60.06086248588436], [30.338204920490178, 60.056973718607125], [30.334861594128157, 60.05290084447127], [30.331695247444795, 60.05357637946779], [30.320304351408776, 60.051944367567096], [30.311242952843497, 60.05052470544631], [30.31288190454768, 60.04722795083562], [30.314932179079207, 60.0449462525095], [30.316597332494553, 60.04097491923015], [30.318090824533, 60.038924588566736], [30.311025345359035, 60.03807508348415], [30.306051555092495, 60.03769551824349], [30.303202074365757, 60.03730521388692], [30.302733392226656, 60.03701468691597], [30.296212621821855, 60.03899359187432], [30.29320356745606, 60.03602314993418], [30.29058075118842, 60.033342314379375], [30.285056168915613, 60.03532918600904], [30.280711758609375, 60.03688654508028], [30.273836111290894, 60.03680219320715], [30.267153583021514, 60.036674901332226], [30.261041334207032, 60.034927913234746], [30.25132396738043, 60.03206465698568], [30.244707070768143, 60.030026107519355], [30.23922050886175, 60.02843385495911], [30.23139996764408, 60.026384561780006], [30.225258099134866, 60.02393942653649], [30.219097617048927, 60.021436902947244], [30.198479867333873, 60.029966354394844], [30.218268314807613, 60.042617802025916], [30.23273525959578, 60.04753867815768], [30.22728220970058, 60.052877553787816], [30.241354502577167, 60.05761304608063], [30.25095799729902, 60.05336503591615], [30.267933388842497, 60.05867810143432], [30.277634629537502, 60.0603750248393], [30.28295850512029, 60.06177151249851], [30.29755921375003, 60.0660753681169], [30.3030473908755, 60.06749506316247], [30.30699061560845, 60.069450914595514], [30.309469731700254, 60.07121760043045], [30.319921127946454, 60.07706667375058], [30.3313156971953, 60.081764452782814], [30.35025780589914, 60.08422861992534], [30.358381497331354, 60.08223962102955], [30.380263386749306, 60.07777208420947], [30.396802001234914, 60.080897036888516], [30.404145394739984, 60.07585520435717], [30.4082462449349, 60.0730337526781], [30.408742206213862, 60.07021205882941], [30.41707752227686, 60.069648811967916], [30.42556556697953, 60.06970366022033], [30.437057685778917, 60.069286641711734], [30.44100872422905, 60.06969078425705], [30.45466278964631, 60.0710830502156], [30.46123464384931, 60.067838036167075], [30.467634836675387, 60.06523624657655], [30.47065052384116, 60.0645801267158], [30.48654880918339, 60.05987446853102], [30.489047907860947, 60.04998898842541], [30.496918310407775, 60.03888313276422], [30.49797818361727, 60.034745927084174], [30.4971497816802, 60.02983513311942], [30.498767554364697, 60.0259330372593], [30.50026308621482, 60.02273605742237], [30.501354174893788, 60.01847381802478], [30.503818554588378, 60.01429696526781], [30.504028568188648, 60.01130194667555], [30.503551936281184, 60.008435586081006], [30.504658608989693, 60.00575384876503], [30.502465363312663, 60.0034028082132], [30.50239870873585, 60.001582447537416], [30.503190361043874, 59.999375092424316], [30.50438286444088, 59.995789774310666], [30.506639125202053, 59.99216548314177], [30.50623463462038, 59.98737970321657], [30.508687219619322, 59.982451524273095], [30.521595293588053, 59.98047908921794], [30.53124180139465, 59.97721604080878], [30.53736925097361, 59.975759527829396], [30.542981716421814, 59.97335647164223], [30.54810537773483, 59.971229849971174], [30.552199070786095, 59.967381929173285], [30.55450340937716, 59.964532584903466], [30.553546181806112, 59.96065007609903], [30.550601758402212, 59.95624134569204], [30.547287832248866, 59.953234193277055], [30.545518858488087, 59.95108780652325], [30.54129426545885, 59.94610569534193], [30.536400094920726, 59.93094775747016], [30.528116522835294, 59.922245886393924], [30.52566943756627, 59.917506718313284], [30.526524101861263, 59.90199266455649], [30.523547577015684, 59.89058354350366], [30.528810798263795, 59.88042167459086], [30.53182090547316, 59.872652512453435], [30.53088280101263, 59.868032329763224], [30.5151020205584, 59.85879003190356], [30.508499090658358, 59.8558086272493], [30.502067822135338, 59.85429502197966], [30.480107232110804, 59.853469784508654], [30.465503687614998, 59.84976055167714], [30.460169857474714, 59.84717377904005], [30.452003614614657, 59.83717886895841], [30.439717498707783, 59.82856372830762], [30.434668782032418, 59.82582188431399], [30.427388467456648, 59.823684862263455], [30.413686145189917, 59.8207070675232], [30.402558743577405, 59.81846382428624], [30.38216162760953, 59.816306883543504], [30.371528074790138, 59.81521544128535], [30.357799890909746, 59.81518845163753], [30.350594839353572, 59.81412396317776], [30.34047627066507, 59.81078435005675], [30.333275945384784, 59.81003860902005], [30.327852053424262, 59.81014284298805], [30.32289512511299, 59.81124168785228], [30.309526789331034, 59.81700923649475], [30.29321566169256, 59.8253359950535], [30.28462929601698, 59.831327548188824], [30.27564680175945, 59.83189478617195], [30.266835968878866, 59.8338445752037], [30.22539251605207, 59.82492466814427], [30.208129735163954, 59.823354731995984], [30.198248393484864, 59.82285309707915], [30.18819539042883, 59.82304295273767], [30.146719500089233, 59.824751193006634], [30.12790291150744, 59.82663219989353], [30.127582836292365, 59.8368733879679], [30.13052432723933, 59.84162623288087], [30.13057082231689, 59.847588798682565], [30.131514959890122, 59.85080601678217], [30.137952261525868, 59.85644079446912], [30.13949721391844, 59.865117774627805], [30.16343681653671, 59.87965599535078], [30.16195444729382, 59.88531705979706], [30.170600099291153, 59.88882060015389], [30.18194456411583, 59.88434915576466], [30.192979152994607, 59.87920874952303], [30.20169172270454, 59.87515790598621], [30.204700180028695, 59.873942713478364], [30.20942525112242, 59.872123321957034], [30.216661170284564, 59.869546377635096], [30.222231921856036, 59.86746776385042], [30.229347625820076, 59.86491422272238], [30.249506220259754, 59.86443767027905]];

var deliveryZones = [{
  minSum: 800,
  color: '#44c373',
  coords: coords800,
  fitMapByPolygon: false
}, {
  minSum: 1200,
  color: '#1e98ff',
  coords: coords1200,
  fitMapByPolygon: false
}, {
  minSum: 1400,
  color: '#ed4543',
  coords: coords1400,
  fitMapByPolygon: true
}];



/***/ }),

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_script_lang_js___ = __webpack_require__(247);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App',
  data: function data() {
    return {
      initDone: false
    };
  },
  beforeUpdate: function beforeUpdate() {
    if (!this.initDone) {
      this.init();
    }
  },

  methods: {
    init: function init() {
      this.$store.dispatch('marketing/processSpecificQueryParams', {}, { global: true });
      this.initDone = true;
    }
  }
});

/***/ }),

/***/ 265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SvgInlineImage_vue_vue_type_script_lang_js___ = __webpack_require__(266);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SvgInlineImage_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
//
//
//
//

// let cache = new Map()

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SvgInline',
  props: {
    src: { type: String, required: true }
  },
  mounted: function mounted() {}
  // async mounted () {
  //   if (!cache.has(this.src)) {
  //     try {
  //       cache.set(this.src, fetch(this.src).then(r => r.text()))
  //     } catch (e) {
  //       cache.delete(this.src)
  //     }
  //   }
  //   if (cache.has(this.src)) {
  //     const el = await cache.get(this.src)
  //     const domNode = new DOMParser().parseFromString(el, 'text/html').body.childNodes[0]
  //     if (domNode && this.className) {
  //       domNode.classList.add(this.className)
  //     }
  //     this.$el.outerHTML = domNode.outerHTML
  //   }
  // }

});

/***/ }),

/***/ 267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Rub_vue_vue_type_script_lang_js___ = __webpack_require__(268);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Rub_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Rub',
  props: {
    bold: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Menu_vue_vue_type_script_lang_js___ = __webpack_require__(270);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Menu_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_filter__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_shuffle__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_shuffle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_shuffle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_take__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_take___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_take__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_components_ContentLoader__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_components_CategoryDishesList__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_components_CategoryDishesSwiper__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_blocks_SmartphoneCategories__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_blocks_MenuBannersSlider__ = __webpack_require__(727);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MenuPage',
  components: {
    ContentLoader: __WEBPACK_IMPORTED_MODULE_5__src_components_ContentLoader__["a" /* default */],
    CategoryDishesList: __WEBPACK_IMPORTED_MODULE_6__src_components_CategoryDishesList__["a" /* default */],
    SmartphoneCategories: __WEBPACK_IMPORTED_MODULE_8__src_blocks_SmartphoneCategories__["a" /* default */],
    CategoryDishesSwiper: __WEBPACK_IMPORTED_MODULE_7__src_components_CategoryDishesSwiper__["a" /* default */],
    MenuBannersSlider: __WEBPACK_IMPORTED_MODULE_9__src_blocks_MenuBannersSlider__["a" /* default */]
  },
  data: function data() {
    return {
      specialCategories: []
    };
  },

  methods: {
    getRandomDishes: function getRandomDishes(n) {
      return __WEBPACK_IMPORTED_MODULE_3_lodash_take___default()(__WEBPACK_IMPORTED_MODULE_2_lodash_shuffle___default()(this.dishes), n);
    },
    getPopularDishes: function getPopularDishes() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(this.dishes, function (dish) {
        return dish.is_popular && !dish.season_offer;
      });
    },
    getSeasonOffers: function getSeasonOffers() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(this.dishes, function (dish) {
        return dish.season_offer;
      });
    }
  },
  mounted: function mounted() {
    this.specialCategories = [{
      title: 'Популярные блюда',
      dishesCount: this.isSmartphone ? 5 : 12,
      method: this.getPopularDishes
    }, {
      title: 'Сезонные предложения',
      dishesCount: this.isSmartphone ? 5 : 12,
      method: this.getSeasonOffers
      // {
      //   title: 'Случайные блюда (пример 2)',
      //   dishesCount: this.isSmartphone ? 7 : 8
      // }
    }];
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    currentCategory: 'menu/currentCategory',
    categories: 'menu/categories',
    dishes: 'menu/dishes',
    menuLoaded: 'menu/menuLoaded',
    currentFirstLevelCategory: 'menu/currentFirstLevelCategory'
  }))
});

/***/ }),

/***/ 288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ContentLoader_vue_vue_type_script_lang_js___ = __webpack_require__(289);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ContentLoader_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 289:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ContentLoader',
  props: {
    title: {
      type: String,
      default: 'Пожалуйста, подождите, мы загружаем данные'
    }
  }
});

/***/ }),

/***/ 290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CategoryDishesList_vue_vue_type_script_lang_js___ = __webpack_require__(291);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CategoryDishesList_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_findIndex__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_Dish__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(30);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CategoryDishesList',
  components: {
    Dish: __WEBPACK_IMPORTED_MODULE_4__src_components_Dish__["a" /* default */]
  },
  props: {
    title: {
      type: String,
      required: true
    },
    dishes: {
      type: Array,
      required: true
    },
    currentCategory: {
      type: Object
    },
    isSpecialList: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    needSelectSubcategory: {
      handler: function handler(newVal) {
        if (newVal && !this.isSpecialList) {
          this.$router.push({ name: 'MenuCategory', params: { currentCategory: this.currentCategory.slug, subcategory: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.subcategories)[0].slug } });
          if (this.getSwiper()) {
            this.slideSubcategories(0);
          }
        }
      },

      immediate: true
    }
  },
  data: function data() {
    return {
      setSubcategoryTimeout: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])({
    menuLoaded: 'menu/menuLoaded',
    residualSubcategory: 'menu/residualSubcategory'
  }), {
    emptyBlocksAmount: function emptyBlocksAmount() {
      return (4 - this.dishes.length % 4) % 4;
    },
    subcategories: function subcategories() {
      if (!this.menuLoaded) {
        return {};
      }
      if (this.isSpecialList) {
        return {};
      }

      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.currentCategory.children).length > 0) {
        return this.currentCategory.children;
      } else if (this.currentCategory.parent.id) {
        if (this.residualSubcategory) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.currentCategory.parent.children, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, this.residualSubcategory.slug, this.residualSubcategory));
        }
        return this.currentCategory.parent.children;
      }

      return {};
    },
    hasSubcategories: function hasSubcategories() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.subcategories).length > 0;
    },
    needSelectSubcategory: function needSelectSubcategory() {
      return this.isSmartphone && this.hasSubcategories && !this.currentCategory.parent;
    },
    currentSubcategoryIndex: function currentSubcategoryIndex() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_lodash_findIndex___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.subcategories), function (s) {
        return s.slug === _this.currentCategory.slug;
      });
    },
    swiperOptions: function swiperOptions() {
      return {
        slidesPerView: 'auto',
        spaceBetween: 0,
        loop: false,
        simulateTouch: true,
        speed: 400,
        centeredSlides: true,
        initialSlide: this.currentSubcategoryIndex
        // on: {
        //   slideChangeTransitionStart: () => {
        //     console.log('slideChangeTransitionStart')
        //   },
        //   slideChange: () => {
        //     console.log('slideChange')
        //   },
        //   slideChangeTransitionEnd: () => {
        //     console.log('slideChangeTransitionEnd')
        //   }
        // }
      };
    }
  }),
  methods: {
    slideSubcategories: function slideSubcategories(index) {
      this.getSwiper().slideTo(index, 500, false);
    },
    switchSubcategory: function switchSubcategory(slug) {
      this.$router.push({ name: 'MenuCategory', params: { currentCategory: this.currentCategory.slug, subcategory: slug } });
    },
    getSwiper: function getSwiper() {
      return this.$refs.mySwiper ? this.$refs.mySwiper.swiper : null;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.getSwiper()) {
      this.getSwiper().on('slideChange', function () {
        clearTimeout(_this2.setSubcategoryTimeout);
        _this2.setSubcategoryTimeout = setTimeout(function () {
          _this2.switchSubcategory(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(_this2.subcategories)[_this2.getSwiper().activeIndex].slug);
        }, 80);
      });
    }
  }
});

/***/ }),

/***/ 293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Dish_vue_vue_type_script_lang_js___ = __webpack_require__(294);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Dish_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_components_QuantitySelector__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_velocity_animate__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_velocity_animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_velocity_animate__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Dish',
  data: function data() {
    return {
      maxLinesCount: 4,
      needCollapse: false,
      symbolsLimit: 90,
      description: ''
    };
  },

  props: {
    dish: {
      type: Object,
      required: true
    },
    giftMode: {
      type: Boolean,
      default: false
    },
    giftSelected: {
      type: Boolean,
      default: false
    }
  },
  components: {
    QuantitySelector: __WEBPACK_IMPORTED_MODULE_3__src_components_QuantitySelector__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    cartLines: 'cart/cartLines'
  }), {
    currentDishLine: function currentDishLine() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(this.cartLines, function (line) {
        return line.id === _this.dish.ID;
      });
    },
    image: function image() {
      return this.dish.image || __webpack_require__(297);
    }
    // description () {
    //   if (this.needCollapse) {
    //     let part = this.removeLastWord(this.dish.desc.substring(0, this.symbolsLimit))
    //     return part + '<span class="more-dots"> ...</span>'
    //   } else {
    //     return this.dish.desc
    //   }
    // }

  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({
    addToCart: 'cart/addToCart',
    removeFromCart: 'cart/removeFromCart'
  }), {
    removeLastWord: function removeLastWord(str) {
      var lastIndex = str.lastIndexOf(' ');
      str = str.substring(0, lastIndex);
      return str;
    },
    getCurrentLinesCount: function getCurrentLinesCount() {
      return Math.round(this.$refs.subtitle.offsetHeight / parseFloat(document.defaultView.getComputedStyle(this.$refs.subtitle).lineHeight));
    },
    cutToMaxLines: function cutToMaxLines() {
      var linesCount = this.getCurrentLinesCount();
      this.$refs.subtitle.setAttribute('data-lines', linesCount);
      if (linesCount > this.maxLinesCount) {
        this.needCollapse = true;
        this.cutLinesIteration();
      }
    },
    cutLinesIteration: function cutLinesIteration() {
      var _this2 = this;

      this.description = this.removeLastWord(this.description);
      this.$nextTick(function () {
        var linesCount = _this2.getCurrentLinesCount();
        if (linesCount > _this2.maxLinesCount) {
          _this2.cutLinesIteration();
        } else {
          // let diff = this.dish.desc.substring(this.description.length)
          // this.description += '<span class="tail">' + diff + '</span>'
          _this2.description += '<span class="full">' + _this2.dish.desc + '</span>';
        }
      });
    },
    addCurrentToCart: function addCurrentToCart() {
      this.addToCart(this.dish.ID);
      if (!this.isSmartphone) {
        this.flyToHeaderCart();
      }
      this.sendSimpleEvent({ category: 'Test', action: 'AddToCart', label: this.dish.post_title, value: this.currentDishLine.quantity });
    },
    flyToHeaderCart: function flyToHeaderCart() {
      var currentImage = this.$refs.currentImage;
      var currentLeft = window.scrollX + currentImage.getBoundingClientRect().left;
      var currentTop = window.scrollY + currentImage.getBoundingClientRect().top;

      var flyingImage = document.createElement('div');
      flyingImage.classList.add('flying-image');
      flyingImage.style.backgroundImage = 'url(\'' + this.image + '\')';
      flyingImage.style.left = currentLeft;
      flyingImage.style.top = currentTop;
      flyingImage.style.width = currentImage.offsetWidth;
      flyingImage.style.height = currentImage.offsetHeight;
      if (this.dish.image_use_contain) {
        flyingImage.classList.add('use-contain');
      }
      document.body.appendChild(flyingImage);

      var headerCart = document.querySelector('#site-header .header-cart');
      var deltaX = window.scrollX + headerCart.getBoundingClientRect().left - currentLeft;
      var deltaY = window.scrollY + headerCart.getBoundingClientRect().top - currentTop;

      __WEBPACK_IMPORTED_MODULE_4_velocity_animate___default()(flyingImage, {
        translateX: deltaX,
        translateY: deltaY,
        scale: 0.6,
        opacity: 0.6
      }, {
        duration: 750,
        easing: 'ease-in-out',
        complete: function complete() {
          flyingImage.remove();
        }
      });
    },
    removeCurrentFromCart: function removeCurrentFromCart() {
      this.removeFromCart(this.dish.ID);
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    this.description = this.dish.desc;
    if (!this.isSmartphone && !this.giftMode) {
      this.$nextTick(function () {
        _this3.cutToMaxLines();
      });
    }
  }
});

/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_QuantitySelector_vue_vue_type_script_lang_js___ = __webpack_require__(296);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_QuantitySelector_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'QuantitySelector',
  props: {
    amount: {
      type: Number,
      required: true
    }
  }
});

/***/ }),

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/nophoto.7c5c663.jpg";

/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CategoryDishesSwiper_vue_vue_type_script_lang_js___ = __webpack_require__(299);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CategoryDishesSwiper_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_components_Dish__ = __webpack_require__(132);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CategoryDishesSwiper',
  data: function data() {
    return {
      swiperOptions: {
        slidesPerView: 'auto',
        spaceBetween: 0,
        pagination: {
          el: '.dishes-slider-pagination',
          clickable: false
        },
        loop: false,
        simulateTouch: true,
        speed: 500
      }
    };
  },

  components: {
    Dish: __WEBPACK_IMPORTED_MODULE_0__src_components_Dish__["a" /* default */]
  },
  props: {
    title: {
      type: String,
      required: true
    },
    dishes: {
      type: Array,
      required: true
    }
  },
  methods: {}
});

/***/ }),

/***/ 300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SmartphoneCategories_vue_vue_type_script_lang_js___ = __webpack_require__(301);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SmartphoneCategories_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(30);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SmartphoneCategories',
  props: {
    hideTitle: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    categories: 'menu/categories'
  }))
});

/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_MenuBannersSlider_vue_vue_type_script_lang_js___ = __webpack_require__(303);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_MenuBannersSlider_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_forEach__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(30);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MenuBannersSlider',
  data: function data() {
    return {
      sliderWidthReady: false,
      sliderWidth: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    promotions: 'content/promotions'
  }), {
    swiperOptions: function swiperOptions() {
      return {
        slidesPerView: '1',
        spaceBetween: 0,
        initialSlide: 0,
        centeredSlides: false,
        navigation: {
          nextEl: '.index-slider-next',
          prevEl: '.index-slider-prev'
        },
        pagination: {
          el: '.index-slider-pagination',
          clickable: true
        },
        loop: true,
        simulateTouch: true,
        speed: 500,
        keyboard: {
          enabled: true,
          onlyInViewport: true
        },
        on: {
          init: function init() {
            setTimeout(function () {
              __WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default()(document.querySelectorAll('.index-slider-pagination .swiper-pagination-bullet'), function (bullet) {
                bullet.style.width = bullet.offsetHeight + 'px';
                bullet.style.height = bullet.offsetHeight + 'px';
              });
            }, 100);
          }
        }
      };
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.sliderWidth = document.querySelector('#right-content .adaptive-column-content').offsetWidth;
      _this.sliderWidthReady = true;
    });
  }
});

/***/ }),

/***/ 305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Conditions_vue_vue_type_script_lang_js___ = __webpack_require__(306);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Conditions_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_forEach__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_store_config_js__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_blocks_PaymentMethods__ = __webpack_require__(737);

 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ConditionsPage',
  data: function data() {
    return {
      map: null,
      zones: __WEBPACK_IMPORTED_MODULE_2__src_store_config_js__["a" /* deliveryZones */],
      polygons: [],
      defaultOpacity: 0.6,
      currentZoneIndex: 0
    };
  },

  components: {
    PaymentMethods: __WEBPACK_IMPORTED_MODULE_3__src_blocks_PaymentMethods__["a" /* default */]
  },
  mounted: function mounted() {
    var _this = this;

    window.ymaps.ready(function () {
      var targetRatio = _this.isSmartphone ? 3.2 / 3.1 : 1047 / 633;
      var mapCont = document.getElementById('map-container');
      var realRatio = mapCont.offsetWidth / mapCont.offsetHeight;
      var mapXDelta = void 0;
      if (_this.isSmartphone) {
        mapXDelta = -0.1;
      } else if (realRatio < targetRatio) {
        mapXDelta = 0;
      } else {
        mapXDelta = (realRatio - targetRatio) * mapCont.offsetHeight * 0.00035;
      }

      _this.map = new window.ymaps.Map('map-container', {
        center: [59.951550, 30.411500 + mapXDelta],
        zoom: _this.isSmartphone ? 10 : 11,
        controls: []
      });
      window.polygons = [];
      __WEBPACK_IMPORTED_MODULE_0_lodash_forEach___default()(_this.zones, function (zone, index) {
        var coords = __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(zone.coords, function (e) {
          return [e[1], e[0]];
        });
        var polygon = new window.ymaps.Polygon([coords], {
          hintContent: 'Бесплатная доставка от ' + _this.numberLingFormWithNumber(zone.minSum, 'рубль', 'рубля', 'рублей')
        }, {
          fillColor: zone.color,
          strokeWidth: 5,
          opacity: _this.defaultOpacity
        });
        _this.map.geoObjects.add(polygon);
        if (!_this.isSmartphone) {
          polygon.events.add('mouseenter', function () {
            _this.$bus.$emit('set-delivery-zone-clients_front', index);
          });
          polygon.events.add('mouseleave', function () {
            _this.$bus.$emit('set-delivery-zone-clients_front', null);
          });
        } else {
          polygon.events.add('click', function () {
            _this.currentZoneIndex = index;
          });
        }
        _this.polygons.push(polygon);
        if (zone.fitMapByPolygon) {
          // this.map.setBounds(polygon.geometry.getBounds(), {
          //   checkZoomRange: true,
          //   preciseZoom: true,
          //   useMapMargin: true,
          //   zoomMargin: 0
          // })
        }
      });
    });

    this.$bus.$on('hover-delivery-zone-left-bar', function (index) {
      if (index === null) {
        __WEBPACK_IMPORTED_MODULE_0_lodash_forEach___default()(_this.polygons, function (p) {
          p.options.set('opacity', _this.defaultOpacity);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_lodash_forEach___default()(_this.polygons, function (p, i) {
          if (i === index) {
            p.options.set('opacity', _this.defaultOpacity);
          } else {
            p.options.set('opacity', 0);
          }
        });
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('hover-delivery-zone-left-bar');
  }
});

/***/ }),

/***/ 307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PaymentMethods_vue_vue_type_script_lang_js___ = __webpack_require__(308);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PaymentMethods_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PaymentMethods'
});

/***/ }),

/***/ 309:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Restaurants_vue_vue_type_script_lang_js___ = __webpack_require__(310);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Restaurants_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 310:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_components_Restaurant__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_components_ContentLoader__ = __webpack_require__(131);

//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RestaurantsPage',
  components: {
    Restaurant: __WEBPACK_IMPORTED_MODULE_2__src_components_Restaurant__["a" /* default */],
    ContentLoader: __WEBPACK_IMPORTED_MODULE_3__src_components_ContentLoader__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    restaurants: 'content/restaurants'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    loadRestaurants: 'content/loadRestaurants'
  })),
  mounted: function mounted() {
    this.loadRestaurants();
  }
});

/***/ }),

/***/ 311:
/***/ (function(module, exports) {

module.exports = "<svg width=\"23px\" height=\"23px\" viewBox=\"0 0 23 23\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>menu food</title><desc>Created with Sketch.</desc><g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"restourant\" transform=\"translate(-406.000000, -480.000000)\" fill=\"#F54A0B\" fill-rule=\"nonzero\"><g id=\"menu-food\" transform=\"translate(406.000000, 480.000000)\"><path d=\"M2.30029772,12.626422 L2.30029772,21.8499995 C2.30011453,22.1550547 2.42121214,22.4476682 2.63691172,22.6633748 C2.8526113,22.8790814 3.14521529,23 3.4502605,23 L19.5497395,23 C19.8547847,23 20.1473887,22.8790814 20.3630883,22.6633748 C20.5787879,22.4476682 20.6998855,22.1550547 20.6997023,21.8499995 L20.6997023,12.626422 C22.6797066,11.145598 23.4875982,8.56233877 22.7041282,6.21720606 C21.9206583,3.87207335 19.7222758,2.29322601 17.2498139,2.29999423 C16.9212104,2.31258216 16.5943169,2.35363757 16.2728055,2.42269926 C15.15938,0.900029128 13.3862899,0 11.5,0 C9.61371011,0 7.84062003,0.900029128 6.72719446,2.42269926 C6.40568313,2.35363757 6.07878962,2.31258216 5.75018607,2.29999423 C3.27772416,2.29322601 1.07934173,3.87207335 0.295871763,6.21720606 C-0.487598204,8.56233877 0.320293412,11.145598 2.30029772,12.626422 L2.30029772,12.626422 Z M4.60022329,20.6999992 L4.60022329,18.3999986 L18.3997767,18.3999986 L18.3997767,20.6999992 L4.60022329,20.6999992 Z M5.55814229,4.61937235 C5.31129901,5.35469563 5.18206295,6.12437386 5.17520468,6.89999546 C5.17520468,7.5351231 5.69006056,8.04999577 6.32516747,8.04999577 C6.96027438,8.04999577 7.47513025,7.5351231 7.47513025,6.89999546 C7.47513025,4.36303728 9.28091681,2.29999423 11.5,2.29999423 C13.7190832,2.29999423 15.5248697,4.36303728 15.5248697,6.89999546 C15.5248697,7.5351231 16.0397256,8.04999577 16.6748325,8.04999577 C17.3099394,8.04999577 17.8247953,7.5351231 17.8247953,6.89999546 C17.817937,6.12437386 17.688701,5.35469563 17.4418577,4.61937235 C18.9629935,4.69419621 20.2521487,5.7641604 20.6059817,7.24551033 C20.9598148,8.72686027 20.2933801,10.2639643 18.9702732,11.0182041 C18.6168904,11.2244618 18.3996593,11.6029099 18.3997767,12.0120918 L18.3997767,16.0999979 L4.60022329,16.0999979 L4.60022329,12.0120918 C4.60034067,11.6029099 4.38310958,11.2244618 4.02972675,11.0182041 C2.70661991,10.2639643 2.0401852,8.72686027 2.39401827,7.24551033 C2.74785133,5.7641604 4.03700652,4.69419621 5.55814229,4.61937235 L5.55814229,4.61937235 Z\" id=\"Shape\"></path></g></g></g></svg>"

/***/ }),

/***/ 312:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Restaurant_vue_vue_type_script_lang_js___ = __webpack_require__(313);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Restaurant_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 313:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_components_Phone__ = __webpack_require__(138);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Restaurant',
  data: function data() {
    return {
      menuPopoverOptionsShown: false
    };
  },

  computed: {
    address: function address() {
      // eslint-disable-next-line no-control-regex
      var res = this.restaurant.acf.address.replace(new RegExp('\r\n', 'g'), '<br/>');
      // if (this.isSmartphone) {
      //   res = res.replace(new RegExp(String.fromCharCode(160), 'g'), ' ')
      // }
      return res;
    },
    metro: function metro() {
      var res = this.restaurant.acf.metro;
      if (this.isSmartphone) {
        res = res.replace(new RegExp(String.fromCharCode(160), 'g'), ' ');
      }
      return res;
    }
  },
  components: {
    Phone: __WEBPACK_IMPORTED_MODULE_0__src_components_Phone__["a" /* default */]
  },
  props: {
    restaurant: {
      type: Object,
      required: true
    }
  },
  methods: {
    openMenuPopoverOptions: function openMenuPopoverOptions(e) {
      this.menuPopoverOptionsShown = true;
      e.stopPropagation();
    },
    hideMenuPopoverOptions: function hideMenuPopoverOptions() {
      this.menuPopoverOptionsShown = false;
    }
  }
});

/***/ }),

/***/ 314:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Phone_vue_vue_type_script_lang_js___ = __webpack_require__(315);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Phone_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 315:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Phone',
  props: {
    phone: {
      type: String,
      default: '+78127701616'
    }
  },
  computed: {
    telLink: function telLink(_ref) {
      var phone = _ref.phone;
      return '+' + phone.replace(/[^0-9.]/g, '');
    }
  },
  filters: {
    formatted: function formatted(phone) {
      phone = '+' + phone.replace(/[^0-9.]/g, '');
      return phone.replace(/(\+\d)(\d{3})(\d{3})(\d{2})(\d{2})/g, '$1 ($2) $3-$4-$5').replace('+7', '8');
    }
  }
});

/***/ }),

/***/ 316:
/***/ (function(module, exports) {

module.exports = "<svg width=\"13px\" height=\"16px\" viewBox=\"0 0 13 16\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><desc>Created with Sketch.</desc><g id=\"удалить\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><path d=\"M2.71875,3.85026738 L10.3671875,3.85026738 C11.2265625,3.85026738 12,4.62032086 12,5.56149733 L12,14.2887701 C12,15.2299465 11.2265625,16 10.3671875,16 L2.71875,16 C1.7734375,16 1,15.2299465 1,14.2887701 L1,5.56149733 C1,4.62032086 1.7734375,3.85026738 2.71875,3.85026738 Z M5.0390625,0 L8.046875,0 C8.9921875,0 8.90625,0.941176471 8.90625,1.62566845 L11.140625,1.62566845 C11.65625,1.62566845 12,2.05347594 12,2.56684492 C12,3.0802139 11.65625,3.42245989 11.140625,3.42245989 L1.9453125,3.42245989 C1.4296875,3.42245989 1,3.0802139 1,2.56684492 C1,2.05347594 1.4296875,1.62566845 1.9453125,1.62566845 L4.09375,1.62566845 C4.09375,0.941176471 4.0078125,0 5.0390625,0 Z M7.703125,1.62566845 C7.6171875,1.36898396 7.359375,1.11229947 7.1015625,1.11229947 L5.984375,1.11229947 C5.640625,1.11229947 5.3828125,1.36898396 5.296875,1.62566845 L7.703125,1.62566845 Z M3.578125,5.64705882 C3.921875,5.64705882 4.09375,5.90374332 4.09375,6.16042781 L4.09375,13.9465241 C4.09375,14.2032086 3.921875,14.459893 3.578125,14.459893 C3.3203125,14.459893 3.1484375,14.2032086 3.1484375,13.9465241 L3.1484375,6.16042781 C3.1484375,5.90374332 3.3203125,5.64705882 3.578125,5.64705882 Z M6.5,5.64705882 C6.7578125,5.64705882 7.015625,5.90374332 7.015625,6.16042781 L7.015625,13.9465241 C7.015625,14.2032086 6.7578125,14.459893 6.5,14.459893 C6.2421875,14.459893 5.984375,14.2032086 5.984375,13.9465241 L5.984375,6.16042781 C5.984375,5.90374332 6.2421875,5.64705882 6.5,5.64705882 Z M9.421875,5.64705882 C9.6796875,5.64705882 9.9375,5.90374332 9.9375,6.16042781 L9.9375,13.9465241 C9.9375,14.2032086 9.6796875,14.459893 9.421875,14.459893 C9.1640625,14.459893 8.90625,14.2032086 8.90625,13.9465241 L8.90625,6.16042781 C8.90625,5.90374332 9.1640625,5.64705882 9.421875,5.64705882 Z\" id=\"Shape\" fill=\"#202020\"></path></g></svg>"

/***/ }),

/***/ 317:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Order_vue_vue_type_script_lang_js___ = __webpack_require__(318);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Order_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_filter__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_forEach__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_components_Phone__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_components_QuantitySelector__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_components_ContentLoader__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_components_InputContainer__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_components_MangalButton__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_components_NarrowCart__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_components_Dish__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_components_GiftDishesSwiper__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuelidate_lib_validators__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_velocity_animate__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_velocity_animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_velocity_animate__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













// const INDEX_OF_NINE = 4

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OrderPage',
  components: {
    GiftDishesSwiper: __WEBPACK_IMPORTED_MODULE_12__src_components_GiftDishesSwiper__["a" /* default */],
    NarrowCart: __WEBPACK_IMPORTED_MODULE_10__src_components_NarrowCart__["a" /* default */],
    QuantitySelector: __WEBPACK_IMPORTED_MODULE_6__src_components_QuantitySelector__["a" /* default */],
    ContentLoader: __WEBPACK_IMPORTED_MODULE_7__src_components_ContentLoader__["a" /* default */],
    InputContainer: __WEBPACK_IMPORTED_MODULE_8__src_components_InputContainer__["a" /* default */],
    MangalButton: __WEBPACK_IMPORTED_MODULE_9__src_components_MangalButton__["a" /* default */],
    Phone: __WEBPACK_IMPORTED_MODULE_5__src_components_Phone__["a" /* default */],
    Dish: __WEBPACK_IMPORTED_MODULE_11__src_components_Dish__["a" /* default */]
  },
  data: function data() {
    var paymentMethods = [{
      code: 'card-offline',
      label: 'Картой курьеру'
    }, {
      code: 'cash',
      label: 'Наличными курьеру'
    }];

    return {
      isLoading: false,
      form: {
        phone: '+7 (',
        people: 1,
        name: '',
        streetHouse: '',
        flat: '',
        comment: '',
        paymentMethod: paymentMethods[0],
        cashChange: 2000,
        promotionsGifts: {}
      },
      noCashChange: false,
      paymentMethods: paymentMethods,
      createOrderFailed: false
    };
  },
  validations: function validations() {
    return {
      form: {
        phone: {
          required: __WEBPACK_IMPORTED_MODULE_13_vuelidate_lib_validators__["required"],
          notEmpty: function notEmpty(input) {
            return !(input === '+7 (');
          },
          // hasNine: input => ((input.length >= 4 && +input[INDEX_OF_NINE] === 9) || input.length <= 4),
          format: function format(input) {
            return input.length > 4 ? /\+7\s\(\d{3}\)\s\d{3}-\d{2}-\d{2}/.test(input) : true;
          }
        },
        people: {
          required: __WEBPACK_IMPORTED_MODULE_13_vuelidate_lib_validators__["required"]
        },
        name: {
          required: __WEBPACK_IMPORTED_MODULE_13_vuelidate_lib_validators__["required"]
        },
        streetHouse: {
          required: __WEBPACK_IMPORTED_MODULE_13_vuelidate_lib_validators__["required"]
        }
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])({
    addToCart: 'cart/addToCart',
    removeFromCart: 'cart/removeFromCart',
    removeLineFromCart: 'cart/removeLineFromCart',
    createOrder: 'cart/createOrder',
    clearCart: 'cart/clearCart'
  }), {
    image: function image(lineImage) {
      return lineImage || __webpack_require__(297);
    },
    onPhoneInput: function onPhoneInput(value) {
      if (value !== '+7 (' && value) {
        this.form.phone = value;
      } else {
        this.form.phone = value;
        // this.$v.phone.$reset()
      }
    },
    processSubmit: function processSubmit() {
      var _this = this;

      if (this.$v.form.$invalid) {
        this.$v.form.$touch();
        __WEBPACK_IMPORTED_MODULE_14_velocity_animate___default()(document.getElementById('order-form'), 'scroll', {
          duration: 300,
          offset: -document.getElementById('site-header').offsetHeight - 10
        });
      } else {
        this.createOrderFailed = false;
        this.isLoading = true;

        if (this.noCashChange) {
          this.form.cashChange = this.totalSum;
        }
        this.createOrder(this.form).then(function (body) {
          // let orderId = body.orderId
          _this.clearCart();
          _this.$router.push({ name: 'SuccessPage', params: { type: 'order' } });
        }).catch(function (e) {
          console.log('e', e);
          _this.createOrderFailed = true;
        }).finally(function () {
          _this.isLoading = false;
        });
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    totalSum: 'cart/totalSum',
    totalSumBeforeDiscount: 'cart/totalSumBeforeDiscount',
    totalItems: 'cart/totalItems',
    cartLinesWithData: 'cart/cartLinesWithData',
    menuLoaded: 'menu/menuLoaded',
    availableGiftsByPromotions: 'cart/availableGiftsByPromotions'
  }), {
    cartHasDiscount: function cartHasDiscount() {
      return this.totalSumBeforeDiscount !== this.totalSum;
    }
  }),
  watch: {
    totalSum: function totalSum(newVal, oldVal) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3_lodash_forEach___default()(this.availableGiftsByPromotions, function (giftPromotionData) {
        var giftIds = __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(giftPromotionData.dishes, function (dish) {
          return !dish.needSum;
        }), function (dish) {
          return dish.ID;
        });
        if (_this2.form.promotionsGifts[giftPromotionData.id]) {
          if (!giftIds.includes(_this2.form.promotionsGifts[giftPromotionData.id].ID)) {
            _this2.$delete(_this2.form.promotionsGifts, giftPromotionData.id);
          }
        }
      });
    }
  },
  mounted: function mounted() {
    if (this.totalItems === 0) {
      this.$router.push({ name: 'Index' });
    }
  }
});

/***/ }),

/***/ 319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InputContainer_vue_vue_type_template_id_5d399475___ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InputContainer_vue_vue_type_script_lang_js___ = __webpack_require__(320);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__InputContainer_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__InputContainer_vue_vue_type_template_id_5d399475___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__InputContainer_vue_vue_type_template_id_5d399475___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_InputContainer_vue_vue_type_script_lang_js___ = __webpack_require__(321);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_InputContainer_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_components_SelectInput__ = __webpack_require__(755);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'InputContainer',
  components: {
    SelectInput: __WEBPACK_IMPORTED_MODULE_0__src_components_SelectInput__["a" /* default */]
  },
  watch: {
    value: function value(newVal) {
      if (this.inputId === 'phone' && newVal.length < 4) {
        this.$emit('input', '+7 (');
      }
    }
  },
  props: {
    label: {
      type: String,
      required: true
    },
    inputId: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'text'
    },
    value: {},
    required: {
      type: Boolean,
      default: false
    },
    selectOptions: {
      type: Array
    }
  },
  methods: {
    processInput: function processInput(ev) {
      if (this.type === 'select') {
        this.$emit('input', ev);
      } else if (this.type === 'checkbox') {
        this.$emit('input', ev.target.checked);
      } else {
        this.$emit('input', ev.target.value);
      }
    }
  }
});

/***/ }),

/***/ 322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SelectInput_vue_vue_type_script_lang_js___ = __webpack_require__(323);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SelectInput_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SelectInput',
  data: function data() {
    return {
      placement: 'down',
      OpenIndicator: {
        render: function render(createElement) {
          return createElement('div', { class: { 'triangle-opener': true } });
        }
      }
    };
  },

  props: {
    inputId: {
      type: String,
      required: true
    },
    value: {},
    options: {
      type: Array,
      required: true
    }
  },
  methods: {
    processInput: function processInput(val) {
      this.$emit('input', val);
    }
  },
  mounted: function mounted() {},

  computed: {
    x: function x() {
      return this.options.map(function (x) {
        return {
          label: x.label,
          value: x.code
        };
      });
    }
  }
});

/***/ }),

/***/ 324:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MangalButton_vue_vue_type_template_id_5dcbecf6___ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MangalButton_vue_vue_type_script_lang_js___ = __webpack_require__(326);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__MangalButton_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__MangalButton_vue_vue_type_template_id_5dcbecf6___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__MangalButton_vue_vue_type_template_id_5dcbecf6___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 326:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_MangalButton_vue_vue_type_script_lang_js___ = __webpack_require__(327);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_MangalButton_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MangalButton',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    text: {
      type: String
    }
  }
});

/***/ }),

/***/ 328:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_NarrowCart_vue_vue_type_script_lang_js___ = __webpack_require__(329);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_NarrowCart_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_components_QuantitySelector__ = __webpack_require__(195);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NarrowCart',
  components: {
    QuantitySelector: __WEBPACK_IMPORTED_MODULE_2__src_components_QuantitySelector__["a" /* default */]
  },
  props: {
    promotionsGifts: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    addToCart: 'cart/addToCart',
    removeFromCart: 'cart/removeFromCart',
    removeLineFromCart: 'cart/removeLineFromCart'
  }), {
    priceInnerHTML: function priceInnerHTML(line) {
      return this.moneyFormat((+line.dish.price - +line.dish.discount) * line.quantity) + '&nbsp;₽';
    },
    crossedPriceInnerHTML: function crossedPriceInnerHTML(line) {
      return this.moneyFormat(+line.dish.price * line.quantity) + '&nbsp;₽';
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    totalSum: 'cart/totalSum',
    totalSumBeforeDiscount: 'cart/totalSumBeforeDiscount',
    cartLinesWithData: 'cart/cartLinesWithData'
  }))
});

/***/ }),

/***/ 330:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GiftDishesSwiper_vue_vue_type_script_lang_js___ = __webpack_require__(331);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GiftDishesSwiper_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 331:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_components_Dish__ = __webpack_require__(132);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'GiftDishesSwiper',
  data: function data() {
    return {
      swiperOptions: {
        slidesPerView: 'auto',
        spaceBetween: 0,
        pagination: {
          el: '.dishes-slider-pagination',
          clickable: false
        },
        loop: false,
        simulateTouch: true,
        speed: 500
      }
    };
  },

  components: {
    Dish: __WEBPACK_IMPORTED_MODULE_0__src_components_Dish__["a" /* default */]
  },
  props: {
    promotionsGifts: {
      type: Object,
      required: true
    },
    giftPromotionData: {
      type: Object,
      required: true
    }
  },
  methods: {}
});

/***/ }),

/***/ 333:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SuccessPage_vue_vue_type_script_lang_js___ = __webpack_require__(334);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SuccessPage_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SuccessPage',
  computed: {
    type: function type() {
      return this.$route.params.type;
    },
    titleText: function titleText() {
      return this.type === 'order' ? 'Ваш заказ оформлен' : 'Ваша заявка получена';
    },
    subtitleText: function subtitleText() {
      return this.type === 'order' ? 'Если мы не позвоним Вам в течение 10&nbsp;минут, пожалуйста свяжитесь с нами.' : 'Если мы не позвоним Вам в течение дня, пожалуйста свяжитесь с нами.';
    }
  }
});

/***/ }),

/***/ 335:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ReserveTable_vue_vue_type_script_lang_js___ = __webpack_require__(336);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ReserveTable_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_components_Phone__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_ContentLoader__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_components_InputContainer__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_components_MangalButton__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_velocity_animate__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_velocity_animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_velocity_animate__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ReserveTablePage',
  components: {
    ContentLoader: __WEBPACK_IMPORTED_MODULE_4__src_components_ContentLoader__["a" /* default */],
    InputContainer: __WEBPACK_IMPORTED_MODULE_5__src_components_InputContainer__["a" /* default */],
    MangalButton: __WEBPACK_IMPORTED_MODULE_6__src_components_MangalButton__["a" /* default */],
    Phone: __WEBPACK_IMPORTED_MODULE_3__src_components_Phone__["a" /* default */]
  },
  data: function data() {
    return {
      isLoading: false,
      form: {
        phone: '+7 (',
        people: 1,
        name: '',
        comment: ''
      },
      reserveFailed: false
    };
  },
  validations: function validations() {
    return {
      form: {
        phone: {
          required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"],
          notEmpty: function notEmpty(input) {
            return !(input === '+7 (');
          },
          // hasNine: input => ((input.length >= 4 && +input[INDEX_OF_NINE] === 9) || input.length <= 4),
          format: function format(input) {
            return input.length > 4 ? /\+7\s\(\d{3}\)\s\d{3}-\d{2}-\d{2}/.test(input) : true;
          }
        },
        people: {
          required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
        },
        name: {
          required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
        }
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({
    loadRestaurants: 'content/loadRestaurants',
    reserveTable: 'reserveTable'
  }), {
    onPhoneInput: function onPhoneInput(value) {
      if (value !== '+7 (' && value) {
        this.form.phone = value;
      } else {
        this.form.phone = value;
        // this.$v.phone.$reset()
      }
    },
    processSubmit: function processSubmit() {
      var _this = this;

      if (this.$v.form.$invalid) {
        this.$v.form.$touch();
        __WEBPACK_IMPORTED_MODULE_8_velocity_animate___default()(document.getElementById('order-form'), 'scroll', {
          duration: 300,
          offset: -document.getElementById('site-header').offsetHeight - 10
        });
      } else {
        this.reserveFailed = false;
        this.isLoading = true;

        this.form.restaurant = this.restaurant.acf.short_address;

        this.reserveTable(this.form).then(function (body) {
          _this.$router.push({ name: 'SuccessPage', params: { type: 'reserve' } });
        }).catch(function (e) {
          console.log('e', e);
          _this.reserveFailed = true;
        }).finally(function () {
          _this.isLoading = false;
        });
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    restaurants: 'content/restaurants'
  }), {
    restaurantSlug: function restaurantSlug() {
      return this.$route.params.restaurant;
    },
    restaurant: function restaurant() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(this.restaurants, function (r) {
        return r.slug === _this2.restaurantSlug;
      });
    }
  }),
  mounted: function mounted() {
    this.loadRestaurants();
  }
});

/***/ }),

/***/ 337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SlideGen_vue_vue_type_script_lang_js___ = __webpack_require__(338);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SlideGen_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SlideGen',
  components: {}
});

/***/ }),

/***/ 339:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 345:
/***/ (function(module, exports) {

module.exports = {
  NODE_ENV: '"production"',
  API_ROOT: 'https://mangalgril.ru',
  FRONT_URL: 'http://mangalgril.ru'
};

/***/ }),

/***/ 363:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SmartphoneCategories_vue_vue_type_template_id_63fd47aa___ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SmartphoneCategories_vue_vue_type_script_lang_js___ = __webpack_require__(300);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__SmartphoneCategories_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__SmartphoneCategories_vue_vue_type_template_id_63fd47aa___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SmartphoneCategories_vue_vue_type_template_id_63fd47aa___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NarrowCart_vue_vue_type_template_id_0a727c56___ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NarrowCart_vue_vue_type_script_lang_js___ = __webpack_require__(328);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__NarrowCart_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__NarrowCart_vue_vue_type_template_id_0a727c56___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__NarrowCart_vue_vue_type_template_id_0a727c56___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 365:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(366);
module.exports = __webpack_require__(568);


/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony default export */ __webpack_exports__["a"] = ({
  menu: {
    SET_CATEGORIES: 'SET_CATEGORIES',
    SET_DISHES: 'SET_DISHES'
  },
  cart: {
    ADD_ITEM: 'ADD_ITEM',
    REMOVE_ITEM: 'REMOVE_ITEM',
    REMOVE_LINE: 'REMOVE_LINE',
    CLEAR_CART: 'CLEAR_CART'
  },
  content: {
    SET_PROMOTIONS: 'SET_PROMOTIONS',
    SET_RESTAURANTS: 'SET_RESTAURANTS'
  },
  marketing: {
    SET_SPECIFIC_QUERY_PARAMS_FULLY: 'SET_SPECIFIC_QUERY_PARAMS_FULLY'
  }
});

/***/ }),

/***/ 568:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventBus", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_head__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_head__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_gtm__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_gtm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_gtm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_moment__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_v_mask__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_click_outside__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_click_outside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_awesome_swiper__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuelidate__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex_router_sync__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_portal_vue__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_portal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_portal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__plugins_scroll__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_SvgInlineImage__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_select__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Rub__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__router__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__store__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__mixin__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__mixin_root__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__mixin_gtm__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_styles_main_scss__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__assets_styles_main_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_js_cookie__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_js_cookie__);


/// / The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



// Основные



// Дополнительные








// не работает без doctype на мобилах
// import VueWaypoint from 'vue-waypoint'
// Локальные





// modules






// Ошибки
// import Raven from 'raven-js'
// import RavenVue from 'raven-js/plugins/vue'

// plugins
// import FacebookApiWrapper from './plugins/facebook-api-wrapper'
// import VK from './plugins/vkontakte-api-wrapper/VK'
// import VkontakteApiWrapper from './plugins/vkontakte-api-wrapper'




// SVG shim
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_gtm___default.a, {
  debug: __WEBPACK_IMPORTED_MODULE_23_js_cookie___default.a.get('gtm_debug') ? __WEBPACK_IMPORTED_MODULE_23_js_cookie___default.a.get('gtm_debug') : false // Whether or not display console logs debugs (optional)
});

// getting API_ROOT
// const configDev = require('../config/dev.env.js')
// const configProd = require('../config/prod.env.js')

// по усполчанию смотрим в куки и загружаем конфиг для стэйджа
// let API_ROOT = Cookies.get('API_ROOT') ? Cookies.get('API_ROOT') : configDev.API_ROOT
// // let FRONT_URL = Cookies.get('FRONT_URL') ? Cookies.get('FRONT_URL') : configDev.FRONT_URL
// if (process.env.NODE_ENV === 'production') {
//   // если билд для прода то смотрим в куки или в конфиг для прода
//   API_ROOT = Cookies.get('API_ROOT') ? Cookies.get('API_ROOT') : configProd.API_ROOT
//   // FRONT_URL = Cookies.get('FRONT_URL') ? Cookies.get('FRONT_URL') : configProd.FRONT_URL
// }

__webpack_require__(172);
/*
* plugins
* */

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_awesome_swiper___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_head___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13__plugins_scroll__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_moment___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vuelidate___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_portal_vue___default.a);

// Vue.use(VK)
// Vue.use(VkontakteApiWrapper, { appId: 6342461 })

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('svg-inline', __WEBPACK_IMPORTED_MODULE_14__components_SvgInlineImage__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('rub', __WEBPACK_IMPORTED_MODULE_16__components_Rub__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].directive('click-outside', __WEBPACK_IMPORTED_MODULE_8_vue_click_outside___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].directive('mask', __WEBPACK_IMPORTED_MODULE_7_v_mask__["a" /* VueMaskDirective */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('v-select', __WEBPACK_IMPORTED_MODULE_15_vue_select___default.a);
// Waypoint plugin
// не работает без doctype на мобилах
// Vue.use(VueWaypoint)

// if (process.env.NODE_ENV === 'production') {
//   Raven
//     .config('https://eeac5a2970a84d53bbc382b36afca9ff@sentry.io/288025', {
//       release: '1.1.1',
//       autoBreadcrumbs: {
//         'xhr': false,      // XMLHttpRequest
//         'console': true,  // console logging
//         'dom': true,       // DOM interactions, i.e. clicks/typing
//         'location': true, // url changes, including pushState/popState
//         'sentry': true     // sentry events
//       }
//     })
//     .addPlugin(RavenVue, Vue)
//     .install()
// }

__WEBPACK_IMPORTED_MODULE_17__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (to.path !== from.path) {
    // store.dispatch('gtm/changeUrl')
  }
  next();
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.options.crossOrigin = true;
// Vue.http.interceptors.push((request, next) => {
//   const token = Cookies.get('client_token')
//
//   if (token && request.url.includes(API_ROOT)) {
//     request.headers.set('X-Client-Token', token)
//   }
//   if (request.url.startsWith(API_ROOT)) {
//     const antiCaptchaToken = router.currentRoute.query.no_captcha || Cookies.get('no_captcha')
//     if (antiCaptchaToken) {
//       request.headers.set('X-Anticaptcha-Token', antiCaptchaToken)
//     }
//   }
//   next(response => {
//     if (response.status === 401) {
//       Cookies.remove('client_id_h')
//       store.dispatch('client/logout')
//     }
//   })
// })

// Create a global Event Bus
// export let eventBus = new Vue()
var EventBus = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]();
Object(__WEBPACK_IMPORTED_MODULE_11_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_17__router__["a" /* default */]);

// Add to Vue properties by exposing a getter for $bus
__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype, {
  $bus: {
    get: function get() {
      return EventBus;
    }
  }
});

/* eslint-disable no-new */
var root = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_17__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */],
  mixins: [__WEBPACK_IMPORTED_MODULE_20__mixin_root__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__mixin_gtm__["a" /* default */]],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

if (false) {
  window.app = root;
}

/***/ }),

/***/ 577:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_vue_vue_type_template_id_4f0ed6e0___ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue_vue_type_script_lang_js___ = __webpack_require__(246);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__App_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__App_vue_vue_type_template_id_4f0ed6e0___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__App_vue_vue_type_template_id_4f0ed6e0___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 578:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_template_id_4f0ed6e0___ = __webpack_require__(579);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_template_id_4f0ed6e0___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_template_id_4f0ed6e0___["b"]; });


/***/ }),

/***/ 579:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []



/***/ }),

/***/ 580:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en-SG": 249,
	"./en-SG.js": 249,
	"./en-au": 250,
	"./en-au.js": 250,
	"./en-ca": 251,
	"./en-ca.js": 251,
	"./en-gb": 252,
	"./en-gb.js": 252,
	"./en-ie": 253,
	"./en-ie.js": 253,
	"./en-il": 254,
	"./en-il.js": 254,
	"./en-nz": 255,
	"./en-nz.js": 255,
	"./ru": 172,
	"./ru.js": 172
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 584;

/***/ }),

/***/ 593:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

var MGSmoothScrollPlugin = {
  install: function install(Vue) {
    Vue.directive('mg-smooth-scroll', {
      inserted: function inserted(el, binding) {
        // Do not initialize smoothScroll when running server side, handle it in client
        // We do not want this script to be applied in browsers that do not support those
        // That means no smoothscroll on IE9 and below.
        if ((typeof window === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(window)) !== 'object' || window.pageYOffset === void 0) return;
        // Attach the smoothscroll function
        el.addEventListener('click', function (ev) {
          var scrollTo = document.getElementById(this.hash.substring(1));
          if (!scrollTo) return;

          ev.preventDefault();

          // Using the history api to solve issue: back doesn't work
          // most browser don't update :target when the history api is used:
          // THIS IS A BUG FROM THE BROWSERS.
          if (window.history.pushState && location.hash !== this.hash) window.history.pushState('', '', this.hash);

          // Get duration from element, default to 500ms
          var duration = binding.value && binding.value.duration ? binding.value['duration'] : 500;

          var autoDetectOffsetByTopBar = binding.value && binding.value.autoDetectOffsetByTopBar ? binding.value['autoDetectOffsetByTopBar'] : false;

          var addPixels = binding.value && binding.value.addPixels ? binding.value['addPixels'] : false;

          var offset;

          if (autoDetectOffsetByTopBar) {
            offset = -document.getElementById('site-header').offsetHeight;
          } else {
            offset = binding.value && binding.value.offset ? binding.value['offset'] : 0;
          }

          if (addPixels) {
            offset += addPixels;
          }

          var clock = Date.now();

          // Get the top position of an element in the document
          // return value of html.getBoundingClientRect().top ... IE : 0, other browsers : -pageYOffset
          var end = scrollTo.nodeName === 'HTML' ? -window.pageYOffset : scrollTo.getBoundingClientRect().top + window.pageYOffset;

          // Ajusts offset from the end
          end += offset;

          // we use requestAnimationFrame to be called by the browser before every repaint
          var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function (fn) {
            window.setTimeout(fn, 15);
          };

          var step = function step() {
            // the time elapsed from the beginning of the scroll
            var elapsed = Date.now() - clock;
            // calculate the scroll position we should be in
            var position = end;
            if (elapsed < duration) {
              position = window.pageYOffset + (end - window.pageYOffset) * easeInOutCubic(elapsed / duration);
              requestAnimationFrame(step);
            } else {
              // fuck chinese guys :(
              window.history.pushState('', '', '#' + scrollTo.id);
              // location.replace('#' + scrollTo.id)
              // this will cause the :target to be activated.
            }
            window.scroll(0, position);
          };
          step();
        });
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (MGSmoothScrollPlugin);

// ease in out function thanks to:
// http://blog.greweb.fr/2012/02/bezier-curve-based-easing-functions-from-concept-to-implementation/
function easeInOutCubic(t) {
  return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
}

/***/ }),

/***/ 613:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SvgInlineImage_vue_vue_type_template_id_79834075___ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SvgInlineImage_vue_vue_type_script_lang_js___ = __webpack_require__(265);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__SvgInlineImage_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__SvgInlineImage_vue_vue_type_template_id_79834075___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SvgInlineImage_vue_vue_type_template_id_79834075___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 614:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SvgInlineImage_vue_vue_type_template_id_79834075___ = __webpack_require__(615);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SvgInlineImage_vue_vue_type_template_id_79834075___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SvgInlineImage_vue_vue_type_template_id_79834075___["b"]; });


/***/ }),

/***/ 615:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"svg-cont",domProps:{"innerHTML":_vm._s(_vm.src)}})}
var staticRenderFns = []



/***/ }),

/***/ 617:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Rub_vue_vue_type_template_id_5cb6952b_functional_true___ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Rub_vue_vue_type_script_lang_js___ = __webpack_require__(267);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Rub_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Rub_vue_vue_type_template_id_5cb6952b_functional_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Rub_vue_vue_type_template_id_5cb6952b_functional_true___["b" /* staticRenderFns */],
  true,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 618:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Rub_vue_vue_type_template_id_5cb6952b_functional_true___ = __webpack_require__(619);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Rub_vue_vue_type_template_id_5cb6952b_functional_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Rub_vue_vue_type_template_id_5cb6952b_functional_true___["b"]; });


/***/ }),

/***/ 619:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function (_h,_vm) {var _c=_vm._c;return (_vm.bold)?_c('b',[_vm._v("₽")]):_c('span',[_vm._v("₽")])}
var staticRenderFns = []



/***/ }),

/***/ 620:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__functions_beforeEach__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__functions_scrollBehavior__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_indexRoutes__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_pages_tech_SlideGen__ = __webpack_require__(792);










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = __WEBPACK_IMPORTED_MODULE_4__modules_indexRoutes__["a" /* default */];

if (false) {
  routes.push({
    path: '/slide',
    name: 'SlideRoute',
    component: SlideGen
  });
}

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__functions_scrollBehavior__["a" /* scrollBehavior */])(to, from, savedPosition);
  },

  routes: routes
});

router.beforeEach(function (to, from, next) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__functions_beforeEach__["a" /* beforeEach */])(to, from, next);
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 622:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return beforeEach; });
// import Cookies from 'js-cookie'
// import store from '/src/store'
// import DeviceDetector from '@/plugins/device-detector'

var beforeEach = function beforeEach(to, from, next) {
  // console.log('to.name', to.name, to.meta)
  if (to.name === 'SuccessPage') {
    to.meta.headerTitle = to.params.type === 'order' ? 'Оформление заказа' : 'Бронирование столика';
  }
  next();
};

/***/ }),

/***/ 623:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return scrollBehavior; });
// import {EventBus} from '/src/main'

var scrollBehavior = function scrollBehavior(to, from, savedPosition) {
  // console.log('sb from', from)
  // console.log('sb to', to)
  // console.log('sb sp', savedPosition)
  // если переход происходит на самом деле в рамках одной странице, то произойдёт скролл плагином
  // но на самом деле, если человек сделает переход на якорь без обновления страницы (через адресную строку), то тоже произойдёт этот случай
  // и прокрутка произойдёт неправильно, но на это в принципе можно забить
  // if (to.name === from.name && !to.params.allowScrollToHash) {
  //   return
  // }
  // если есть якорь, но переход с другой страницы, надо руками сделать выбор ординаты, как в плагине
  if (to.hash) {
    // тут почему-то был промис с шиной. пока закомментил, надо разобраться втф
    // return new Promise((resolve, reject) => {
    //   EventBus.$on('scroll.stuff.loaded', () => {
    //     let offset = 0
    //     let navbar = document.getElementById('navbar')
    //     if (navbar) {
    //       offset = navbar.offsetHeight
    //     }
    //     resolve({ selector: to.hash, offset: { x: 0, y: offset } })
    //   })
    // })
    var offset = 0;
    var navbar = document.getElementById('navbar');
    if (navbar) {
      offset = navbar.offsetHeight;
    }
    return { selector: to.hash, offset: { x: 0, y: offset }
      // return { selector: to.hash, offset: { x: 0, y: offset } }
    };
  }
  if (savedPosition) {
    return savedPosition;
  }
  return { x: 0, y: 0

    // // TODO: Leha `from` is an Object do something with this
    // // this function should return object with coordinates not router`s object
    // // console.warn('Scroll behavior', from, to.name)
    // let allowed = ['GetMenuPlan', 'MobileGetMenuPlan', 'TargetDetails', 'WeekMenu', 'CreateNewOrder', 'TryCustomization']
    // return { x: 0, y: allowed.includes(to.name) ? 0 : from }
  };
};

/***/ }),

/***/ 624:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_pages_index_Menu_vue__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_pages_index_Conditions_vue__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_pages_index_Restaurants_vue__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_pages_index_Order_vue__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_pages_index_SuccessPage_vue__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_pages_index_ReserveTable_vue__ = __webpack_require__(789);





// import AboutPage from '/src/pages/index/About.vue'


var IndexPage = function IndexPage() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 892));
};

// const MenuPage = () => import('/src/pages/clients_front/Menu.vue')
// const ConditionsPage = () => import('/src/pages/clients_front/Conditions.vue')
// const RestaurantsPage = () => import('/src/pages/clients_front/Restaurants.vue')

var indexRoutes = {
  path: '/',
  component: IndexPage,
  // meta: { businessProduct: '' },
  children: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_0__src_pages_index_Menu_vue__["a" /* default */],
    name: 'Index',
    meta: { title: 'Ресторан Мангал и Гриль', leftBarComponent: 'DesktopCategories' }
  }, {
    path: 'menu/:category/:subcategory?',
    component: __WEBPACK_IMPORTED_MODULE_0__src_pages_index_Menu_vue__["a" /* default */],
    name: 'MenuCategory',
    meta: { title: 'Ресторан Мангал и Гриль - меню', leftBarComponent: 'DesktopCategories' }
  }, {
    path: 'conditions',
    component: __WEBPACK_IMPORTED_MODULE_1__src_pages_index_Conditions_vue__["a" /* default */],
    name: 'Conditions',
    meta: { title: 'Доставка и оплата', leftBarComponent: 'ConditionsLeftBar', headerTitle: 'Доставка и оплата' }
  }, {
    path: 'restaurants',
    component: __WEBPACK_IMPORTED_MODULE_2__src_pages_index_Restaurants_vue__["a" /* default */],
    name: 'Restaurants',
    meta: { title: 'Наши рестораны', headerTitle: 'Рестораны' }
  }, {
    path: 'order',
    component: __WEBPACK_IMPORTED_MODULE_3__src_pages_index_Order_vue__["a" /* default */],
    name: 'Order',
    meta: { title: 'Оформление заказа', headerTitle: 'Оформление заказа' }
  }, {
    path: 'thankyou/:type',
    component: __WEBPACK_IMPORTED_MODULE_4__src_pages_index_SuccessPage_vue__["a" /* default */],
    name: 'SuccessPage',
    meta: { title: 'Спасибо за заказ' }
  },
  // {
  //   path: 'about',
  //   component: AboutPage,
  //   name: 'About',
  //   meta: { title: 'Шесть', leftBarComponent: 'DesktopCategories', headerTitle: 'О доставке' }
  // },
  {
    path: 'reserve/:restaurant',
    component: __WEBPACK_IMPORTED_MODULE_5__src_pages_index_ReserveTable_vue__["a" /* default */],
    name: 'ReserveTable',
    meta: { title: 'Шесть', headerTitle: 'Бронирование столика' }
  }]

  // const tryCustomization = {
  //   path: '/try-customization',
  //   name: 'TryCustomization',
  //   component: TryCustomization,
  //   meta: { globalPlacement: 'landing' },
  //   children: [
  //     {
  //       path: ':hid',
  //       component: SingleStepOrder,
  //       name: 'SingleStepOrderInTryCustomization'
  //     }
  //   ]
  // }

  // const indexEmailThankYouRoute = {
  //   path: '/thankyou',
  //   name: 'ThankYouForSubscribe',
  //   component: EmailThankYouPage
  // }
  //
  // const indexEmailCollectRoute = {
  //   path: '/nyemail',
  //   name: 'CollectEmail',
  //   component: CollectEmailPage
  // }
  //
  // const weekMenuRoute = {
  //   path: '/week-menu',
  //   name: 'WeekMenu',
  //   component: FullMenu,
  //   meta: { globalPlacement: 'landing' }
  // }

};/* harmony default export */ __webpack_exports__["a"] = ([indexRoutes]);

/***/ }),

/***/ 625:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Menu_vue_vue_type_template_id_df973ac2___ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Menu_vue_vue_type_script_lang_js___ = __webpack_require__(269);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Menu_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Menu_vue_vue_type_template_id_df973ac2___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Menu_vue_vue_type_template_id_df973ac2___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 626:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Menu_vue_vue_type_template_id_df973ac2___ = __webpack_require__(627);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Menu_vue_vue_type_template_id_df973ac2___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Menu_vue_vue_type_template_id_df973ac2___["b"]; });


/***/ }),

/***/ 627:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'loaded': _vm.menuLoaded },attrs:{"id":"menu"}},[_c('div',{staticClass:"adaptive-column-content"},[(!_vm.menuLoaded)?_c('content-loader',{attrs:{"title":"Пожалуйста, подождите, мы загружаем меню"}}):(_vm.currentCategory)?[_c('category-dishes-list',{key:_vm.currentFirstLevelCategory.title.rendered,attrs:{"currentCategory":_vm.currentCategory,"title":_vm.currentCategory.title.rendered,"dishes":_vm.currentCategory.acf.dishes}}),_vm._v(" "),(_vm.specialCategories.length > 0)?_c('category-dishes-list',{key:_vm.specialCategories[1].title,attrs:{"isSpecialList":true,"title":_vm.specialCategories[1].title,"dishes":_vm.specialCategories[1].method()}}):_vm._e()]:[_c('menu-banners-slider'),_vm._v(" "),(_vm.isSmartphone)?_c('smartphone-categories'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"special-categories-content"},_vm._l((_vm.specialCategories),function(category,index){return _c(_vm.isSmartphone ? 'CategoryDishesSwiper' : 'CategoryDishesList',{key:index,tag:"component",attrs:{"isSpecialList":true,"title":category.title,"dishes":category.method()}})}),1)]],2)])}
var staticRenderFns = []



/***/ }),

/***/ 705:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ContentLoader_vue_vue_type_template_id_4f47de90___ = __webpack_require__(706);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ContentLoader_vue_vue_type_template_id_4f47de90___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ContentLoader_vue_vue_type_template_id_4f47de90___["b"]; });


/***/ }),

/***/ 706:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-loader"},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []



/***/ }),

/***/ 707:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CategoryDishesList_vue_vue_type_template_id_677715c4___ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CategoryDishesList_vue_vue_type_script_lang_js___ = __webpack_require__(290);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__CategoryDishesList_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__CategoryDishesList_vue_vue_type_template_id_677715c4___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__CategoryDishesList_vue_vue_type_template_id_677715c4___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 708:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CategoryDishesList_vue_vue_type_template_id_677715c4___ = __webpack_require__(709);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CategoryDishesList_vue_vue_type_template_id_677715c4___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CategoryDishesList_vue_vue_type_template_id_677715c4___["b"]; });


/***/ }),

/***/ 709:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-dishes-list"},[(!_vm.isSmartphone || _vm.isSpecialList)?_c('h2',[_vm._v(_vm._s(_vm.title))]):(_vm.hasSubcategories)?_c('div',{staticClass:"subcategories-swiper"},[_c('swiper',{ref:"mySwiper",staticClass:"subcategories-slider",attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.subcategories),function(subcategory,slug,index){return _c('swiper-slide',{key:subcategory.id},[_c('router-link',{staticClass:"subcategory-link",attrs:{"to":{ name: 'MenuCategory', params: { currentCategory: _vm.currentCategory.slug, subcategory: subcategory.slug } },"active-class":"active"},nativeOn:{"click":function($event){return _vm.slideSubcategories(index)}}},[_c('div',{staticClass:"visible"},[_vm._v(_vm._s(subcategory.title.rendered))]),_c('div',{staticClass:"back"},[_vm._v(_vm._s(subcategory.title.rendered))])])],1)}),1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"grid"},[_vm._l((_vm.dishes),function(dish){return _c('dish',{key:dish.ID,attrs:{"dish":dish}})}),_vm._v(" "),_vm._l((new Array(_vm.emptyBlocksAmount)),function(item,index){return _c('div',{key:index,staticClass:"dish empty"})})],2)])}
var staticRenderFns = []



/***/ }),

/***/ 716:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Dish_vue_vue_type_template_id_af6ec360___ = __webpack_require__(717);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Dish_vue_vue_type_template_id_af6ec360___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Dish_vue_vue_type_template_id_af6ec360___["b"]; });


/***/ }),

/***/ 717:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dish"},[_c('div',{ref:"currentImage",staticClass:"image",class:{ 'use-contain': _vm.dish.image_use_contain },style:({'background-image': ("url('" + _vm.image + "')")})},[(_vm.dish.discount)?_c('div',{staticClass:"promo-mark"},[_vm._v("-"+_vm._s(_vm._f("money")(_vm.dish.discount))+" "),_c('rub')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"size"},[_vm._v(_vm._s(_vm.dish.size))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.dish.post_title))]),_vm._v(" "),(!_vm.giftMode)?_c('div',{ref:"subtitle",staticClass:"subtitle",class:{ 'need-collapse': _vm.needCollapse },domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bottom-row"},[(!_vm.giftMode)?_c('div',{staticClass:"price"},[_vm._v(_vm._s(_vm.dish.price - _vm.dish.discount)+" "),_c('rub',{attrs:{"bold":true}})],1):_c('div',{staticClass:"gift-icon"},[_c('svg-inline',{attrs:{"src":__webpack_require__(193)}})],1),_vm._v(" "),(_vm.dish.discount || _vm.giftMode)?_c('div',{staticClass:"crossed-price"},[_vm._v(_vm._s(_vm.dish.price)+" "),_c('rub',{attrs:{"bold":true}})],1):_vm._e(),_vm._v(" "),(!_vm.giftMode)?[(!_vm.currentDishLine)?_c('div',{staticClass:"button add-to-cart",on:{"click":_vm.addCurrentToCart}},[_vm._v("В корзину")]):_c('quantity-selector',{attrs:{"amount":_vm.currentDishLine.quantity},on:{"clickMinus":_vm.removeCurrentFromCart,"clickPlus":_vm.addCurrentToCart}})]:_c('div',{staticClass:"button select-gift",class:{ 'selected': _vm.giftSelected },on:{"click":function($event){return _vm.$emit('selectGift')}}},[(_vm.giftSelected)?_c('svg-inline',{attrs:{"src":__webpack_require__(718)}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.giftSelected ? 'Выбрано' : 'Выбрать'))])],1)],2)])}
var staticRenderFns = []



/***/ }),

/***/ 718:
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"25\" height=\"25\" viewBox=\"0 0 25 25\"><path fill=\"#F54A0B\" fill-rule=\"nonzero\" d=\"M7.375 10.125l-1.75 1.75L11.25 17.5 23.75 5 22 3.25 11.25 14l-3.875-3.875zM22.5 12.5c0 5.5-4.5 10-10 10s-10-4.5-10-10 4.5-10 10-10c1 0 1.875.125 2.75.375l2-2C15.75.375 14.125 0 12.5 0 5.625 0 0 5.625 0 12.5S5.625 25 12.5 25 25 19.375 25 12.5h-2.5z\"></path></svg>"

/***/ }),

/***/ 720:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_QuantitySelector_vue_vue_type_template_id_43d55a60___ = __webpack_require__(721);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_QuantitySelector_vue_vue_type_template_id_43d55a60___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_QuantitySelector_vue_vue_type_template_id_43d55a60___["b"]; });


/***/ }),

/***/ 721:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quantity-selector"},[_c('div',{staticClass:"control minus",on:{"click":function($event){return _vm.$emit('clickMinus')}}}),_vm._v(" "),_c('div',{staticClass:"amount"},[_vm._v(_vm._s(_vm.amount))]),_vm._v(" "),_c('div',{staticClass:"control plus",on:{"click":function($event){return _vm.$emit('clickPlus')}}})])}
var staticRenderFns = []



/***/ }),

/***/ 722:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CategoryDishesSwiper_vue_vue_type_template_id_521c17d0___ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CategoryDishesSwiper_vue_vue_type_script_lang_js___ = __webpack_require__(298);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__CategoryDishesSwiper_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__CategoryDishesSwiper_vue_vue_type_template_id_521c17d0___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__CategoryDishesSwiper_vue_vue_type_template_id_521c17d0___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 723:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CategoryDishesSwiper_vue_vue_type_template_id_521c17d0___ = __webpack_require__(724);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CategoryDishesSwiper_vue_vue_type_template_id_521c17d0___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CategoryDishesSwiper_vue_vue_type_template_id_521c17d0___["b"]; });


/***/ }),

/***/ 724:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-dishes-swiper"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('swiper',{ref:"mySwiper",staticClass:"dishes-slider",attrs:{"options":_vm.swiperOptions}},[_vm._l((_vm.dishes),function(dish){return _c('swiper-slide',{key:dish.ID},[_c('dish',{attrs:{"dish":dish}})],1)}),_vm._v(" "),_c('div',{staticClass:"dishes-slider-pagination",attrs:{"slot":"pagination"},slot:"pagination"})],2)],1)}
var staticRenderFns = []



/***/ }),

/***/ 725:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SmartphoneCategories_vue_vue_type_template_id_63fd47aa___ = __webpack_require__(726);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SmartphoneCategories_vue_vue_type_template_id_63fd47aa___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SmartphoneCategories_vue_vue_type_template_id_63fd47aa___["b"]; });


/***/ }),

/***/ 726:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"smartphone-categories",class:{ 'hide-title': _vm.hideTitle }},[(!_vm.hideTitle)?_c('h2',[_vm._v("Меню")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"categories-grid"},_vm._l((_vm.categories),function(category){return _c('router-link',{key:category.id,attrs:{"to":{ name: 'MenuCategory', params: { category: category.slug } },"active-class":"active"},nativeOn:{"click":function($event){return _vm.$emit('clickCategory')}}},[_c('div',{staticClass:"icon",style:({'background-image': ("url('" + (category.acf.icon) + "')")})}),_vm._v(" "),_c('span',[_vm._v(_vm._s(category.title.rendered))])])}),1)])}
var staticRenderFns = []



/***/ }),

/***/ 727:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MenuBannersSlider_vue_vue_type_template_id_026a8808___ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MenuBannersSlider_vue_vue_type_script_lang_js___ = __webpack_require__(302);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__MenuBannersSlider_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__MenuBannersSlider_vue_vue_type_template_id_026a8808___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__MenuBannersSlider_vue_vue_type_template_id_026a8808___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 728:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MenuBannersSlider_vue_vue_type_template_id_026a8808___ = __webpack_require__(729);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MenuBannersSlider_vue_vue_type_template_id_026a8808___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MenuBannersSlider_vue_vue_type_template_id_026a8808___["b"]; });


/***/ }),

/***/ 729:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.promotions.length > 0)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sliderWidthReady),expression:"sliderWidthReady"}],ref:"mySwiperContainer",staticClass:"my-index-swiper-container",style:({ width: _vm.sliderWidth + 'px' })},[_c('swiper',{ref:"mySwiper",staticClass:"index-slider",attrs:{"options":_vm.swiperOptions}},[_vm._l((_vm.promotions),function(promotion,index){return _c('swiper-slide',{key:'s' + index,staticStyle:{"width":"auto"}},[_c('div',{staticClass:"banner",style:(("background-image: url('" + ((_vm.isSmartphone ? promotion.acf.banner_mob : promotion.acf.banner)) + "');"))})])}),_vm._v(" "),_c('div',{staticClass:"index-slider-prev",attrs:{"slot":"button-prev"},slot:"button-prev"},[_c('svg-inline',{attrs:{"src":__webpack_require__(730)}})],1),_vm._v(" "),_c('div',{staticClass:"index-slider-next",attrs:{"slot":"button-next"},slot:"button-next"},[_c('svg-inline',{attrs:{"src":__webpack_require__(731)}})],1),_vm._v(" "),_c('div',{staticClass:"index-slider-pagination",attrs:{"slot":"pagination"},slot:"pagination"})],2)],1):_vm._e()}
var staticRenderFns = []



/***/ }),

/***/ 730:
/***/ (function(module, exports) {

module.exports = "<svg width=\"40px\" height=\"40px\" viewBox=\"0 0 40 40\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Group 2</title><desc>Created with Sketch.</desc><g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"стрелочки\"><g id=\"Group-2\"><rect id=\"Rectangle\" stroke=\"#FFFFFF\" stroke-width=\"2.5\" x=\"1.25\" y=\"1.25\" width=\"37.5\" height=\"37.5\" rx=\"8\"></rect><path d=\"M16.3103467,25.7970451 L16.3103467,26.6 C16.6583646,26.6 16.9952143,26.4611418 17.2441587,26.2070173 L22.6236929,20.7223215 C23.1253616,20.2100346 23.1253616,19.3895441 22.6241375,18.877711 L17.2438124,13.3922082 C16.7364056,12.8750313 15.9070365,12.8685259 15.3912506,13.3774507 C14.8751929,13.8875064 14.8689787,14.7202922 15.3766291,15.2377037 L19.851125,19.7997894 L15.3765335,24.3619725 C14.8690628,24.8800773 14.8752722,25.7124923 15.3907678,26.2219928 C15.6391692,26.4670398 15.9695443,26.6 16.3103467,26.6 L16.3103467,25.7970451 Z\" id=\"Path\" fill=\"#FFFFFF\" fill-rule=\"nonzero\" transform=\"translate(19.000000, 19.800000) scale(-1, 1) translate(-19.000000, -19.800000) \"></path></g></g></g></svg>"

/***/ }),

/***/ 731:
/***/ (function(module, exports) {

module.exports = "<svg width=\"40px\" height=\"40px\" viewBox=\"0 0 40 40\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Group 2</title><desc>Created with Sketch.</desc><g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" transform=\"rotate(180 20 20)\"><g id=\"стрелочки\"><g id=\"Group-2\"><rect id=\"Rectangle\" stroke=\"#FFFFFF\" stroke-width=\"2.5\" x=\"1.25\" y=\"1.25\" width=\"37.5\" height=\"37.5\" rx=\"8\"></rect><path d=\"M16.3103467,25.7970451 L16.3103467,26.6 C16.6583646,26.6 16.9952143,26.4611418 17.2441587,26.2070173 L22.6236929,20.7223215 C23.1253616,20.2100346 23.1253616,19.3895441 22.6241375,18.877711 L17.2438124,13.3922082 C16.7364056,12.8750313 15.9070365,12.8685259 15.3912506,13.3774507 C14.8751929,13.8875064 14.8689787,14.7202922 15.3766291,15.2377037 L19.851125,19.7997894 L15.3765335,24.3619725 C14.8690628,24.8800773 14.8752722,25.7124923 15.3907678,26.2219928 C15.6391692,26.4670398 15.9695443,26.6 16.3103467,26.6 L16.3103467,25.7970451 Z\" id=\"Path\" fill=\"#FFFFFF\" fill-rule=\"nonzero\" transform=\"translate(19.000000, 19.800000) scale(-1, 1) translate(-19.000000, -19.800000) \"></path></g></g></g></svg>"

/***/ }),

/***/ 733:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Conditions_vue_vue_type_template_id_c0ccdde8___ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Conditions_vue_vue_type_script_lang_js___ = __webpack_require__(305);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Conditions_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Conditions_vue_vue_type_template_id_c0ccdde8___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Conditions_vue_vue_type_template_id_c0ccdde8___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 734:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Conditions_vue_vue_type_template_id_c0ccdde8___ = __webpack_require__(735);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Conditions_vue_vue_type_template_id_c0ccdde8___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Conditions_vue_vue_type_template_id_c0ccdde8___["b"]; });


/***/ }),

/***/ 735:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"conditions"}},[_c('div',{attrs:{"id":"map-container"}},[_c('div',{staticClass:"adaptive-column-content"},[(!_vm.isSmartphone)?_c('payment-methods'):_vm._e()],1),_vm._v(" "),(_vm.isSmartphone)?_c('div',{staticClass:"current-zone-info"},[_c('div',{staticClass:"marker",style:({ backgroundColor: _vm.zones[_vm.currentZoneIndex].color })}),_vm._v(" "),_c('div',{staticClass:"text"},[_c('div',{staticClass:"title"},[_vm._v("Зона доставки "+_vm._s(_vm.currentZoneIndex + 1))]),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("Минимальный заказ "+_vm._s(_vm.zones[_vm.currentZoneIndex].minSum)+" "),_c('rub')],1)])]):_vm._e()]),_vm._v(" "),(_vm.isSmartphone)?_c('payment-methods'):_vm._e()],1)}
var staticRenderFns = []



/***/ }),

/***/ 737:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PaymentMethods_vue_vue_type_template_id_00a04c60_functional_true___ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PaymentMethods_vue_vue_type_script_lang_js___ = __webpack_require__(307);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__PaymentMethods_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__PaymentMethods_vue_vue_type_template_id_00a04c60_functional_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__PaymentMethods_vue_vue_type_template_id_00a04c60_functional_true___["b" /* staticRenderFns */],
  true,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 738:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PaymentMethods_vue_vue_type_template_id_00a04c60_functional_true___ = __webpack_require__(739);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PaymentMethods_vue_vue_type_template_id_00a04c60_functional_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PaymentMethods_vue_vue_type_template_id_00a04c60_functional_true___["b"]; });


/***/ }),

/***/ 739:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"payment-methods"},[_c('div',{staticClass:"title"},[_vm._v("Способы оплаты заказа")]),_vm._v(" "),_c('div',{staticClass:"methods"},[_c('div',[_c('svg-inline',{attrs:{"src":__webpack_require__(740)}}),_vm._v(" "),_vm._m(0)],1),_vm._v(" "),_c('div',[_c('svg-inline',{attrs:{"src":__webpack_require__(741)}}),_vm._v(" "),_vm._m(1)],1)]),_vm._v(" "),_vm._m(2)])}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"method-title"},[_vm._v("Наличными"),_c('br'),_vm._v("курьеру")])},function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"method-title"},[_vm._v("По карте"),_c('br'),_vm._v("курьеру")])},function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"details"},[_vm._v("Время доставки заказа: от 1 часа"),_c('br'),_vm._v("*Время доставки может изменяться в связи с дорожной ситуацией")])}]



/***/ }),

/***/ 740:
/***/ (function(module, exports) {

module.exports = "<svg width=\"80px\" height=\"83px\" viewBox=\"0 0 80 83\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Наличными курьеру</title><desc>Created with Sketch.</desc><g id=\"Наличными-курьеру\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Group-2\" transform=\"translate(-3.000000, -6.000000)\"><polygon id=\"Path-2\" fill=\"#EB753F\" points=\"8.63103956 29.6190931 26.155102 10.6632653 66.1215922 43.5482229 53.3794915 59.7126797 47.4694571 54.4124887 39.7170068 51.4947543 37.5150869 54.4124887\"></polygon><g id=\"Group\" transform=\"translate(44.712409, 47.901489) rotate(50.000000) translate(-44.712409, -47.901489) translate(0.706853, 27.120239)\" fill=\"#000000\" fill-rule=\"nonzero\"><path d=\"M86.9686135,17.8551055 C86.7273726,17.3183174 86.2829437,16.9001446 85.7336718,16.693122 L78.6658357,14.0150267 C76.3392938,11.9677225 69.2383789,5.83687623 66.1841034,4.2764984 C63.0540712,2.91414459 59.7910302,1.88307293 56.4479111,1.20000878 C56.2929771,0.891941317 56.0659754,0.626139372 55.7863352,0.425353117 C55.3131487,0.0788353328 54.7220438,-0.0645032194 54.1434216,0.0269587767 L1.90097646,8.43750595 C1.31535508,8.51938967 0.78702674,8.83387312 0.434586684,9.3103634 C0.0821466275,9.78685368 -0.0648796043,10.385433 0.0265113505,10.9717366 L4.43701749,38.328148 C4.61173611,39.4105805 5.54980409,40.2014336 6.64227055,40.1873215 C6.76331465,40.1982597 6.88509321,40.1982597 7.00613731,40.1873215 L39.4784887,34.8200645 C40.2565015,34.6915698 40.9071132,34.156256 41.1852446,33.4157706 C41.463376,32.6752852 41.3267724,31.8421256 40.826891,31.2301349 C40.3270096,30.6181443 39.5397943,30.3202985 38.7617815,30.4487932 L8.42852554,35.4287225 L4.75677918,12.4103828 L52.6438495,4.66382623 L55.157838,20.754531 L50.3944914,20.8983956 C50.188377,20.9083845 49.9844732,20.9455932 49.7880468,21.0090607 L42.9958674,23.2223626 C42.0732897,23.5240803 41.4556094,24.3955827 41.4742428,25.3692654 C41.439109,27.1609167 41.6092955,28.9506834 41.981451,30.7033229 C42.6160547,31.9762999 43.4048916,33.1657324 44.3300455,34.244606 C44.8624191,34.8963884 45.7174145,35.1881478 46.5352985,34.9971286 L55.2570744,32.9276913 L60.9135485,33.4699503 L68.4996191,37.8965541 C68.7168949,38.1206255 68.9803135,38.2943609 69.2714577,38.4056135 L69.6022456,38.5273451 C69.8079397,38.6421382 70.0316973,38.7207392 70.2638216,38.7597418 L76.4495564,41.1169083 C76.6966264,41.2092432 76.9577677,41.2579179 77.221395,41.260773 C78.1881992,41.3167873 79.0782865,40.733201 79.4156218,39.8221267 L87.0568237,19.5482814 C87.2525131,18.9945118 87.2207785,18.3853725 86.9686135,17.8551055 Z M61.8507811,29.0986791 L55.3563108,28.4900211 C55.1226089,28.4520025 54.8843318,28.4520025 54.6506298,28.4900211 L46.9322441,30.3159951 C46.6558488,29.9634298 46.4017464,29.5938213 46.1714318,29.2093442 C46.0512643,28.440092 45.9812823,27.6637842 45.9619327,26.8853772 L50.8796471,25.2807333 L57.8261943,25.0594031 L58.1018509,25.0594031 L58.1790347,25.0594031 L58.39956,25.0040706 C58.4687676,24.9869416 58.5354782,24.9609039 58.5980328,24.926605 L58.7965056,24.8380729 L58.9839521,24.7274078 L59.1493461,24.5946097 L59.3037138,24.4618116 L59.4470553,24.295814 L59.5793704,24.1298163 L59.6786068,23.9416857 L59.7778432,23.7646215 L59.8440008,23.5543578 L59.9101584,23.3440942 C59.9161461,23.2741351 59.9161461,23.2037896 59.9101584,23.1338305 C59.9155708,23.0601537 59.9155708,22.986177 59.9101584,22.9125003 L59.9101584,22.8129017 C59.916273,22.7651432 59.916273,22.7167956 59.9101584,22.6690371 L59.9101584,22.536239 L57.2638547,5.93647482 C59.6242206,6.47544757 61.9280834,7.23879359 64.1442443,8.21617576 C66.3494974,9.32282671 71.9287876,14.0371597 75.0712732,16.7595211 L68.9847748,32.9940904 L62.7439086,29.3864083 C62.4683847,29.231477 62.1646757,29.1336344 61.8507811,29.0986791 L61.8507811,29.0986791 Z M76.0305583,36.1812451 L72.943204,35.0081951 L79.0297025,18.8842909 L82.1170568,20.0573409 L76.0305583,36.1812451 Z\" id=\"Shape\"></path><path d=\"M36.6700976,12.4947756 C33.6260347,10.1057003 29.3832003,9.97690155 26.200097,12.1769402 C23.0169936,14.3769789 21.6340856,18.3940743 22.7875085,22.0898872 C23.9409315,25.7857001 27.3623722,28.3004977 31.230564,28.2956355 C31.5941894,28.2960093 31.9574995,28.2741895 32.3184707,28.2302907 C35.8585161,27.7875066 38.785003,25.2567631 39.7367745,21.8151505 C40.6885459,18.373538 39.4787558,14.6966926 36.6700976,12.4947756 Z M34.7445027,22.219215 C33.4910024,23.8037029 31.3321465,24.3506706 29.4765042,23.553915 C27.620862,22.7571594 26.5289416,20.8144085 26.8120214,18.8132519 C27.0951011,16.8120953 28.68293,15.2491531 30.6866107,14.9993904 L31.230564,14.9993904 C32.9423622,15.0051581 34.5013987,15.9863715 35.2483854,17.5280933 C35.995372,19.069815 35.7998502,20.9027891 34.7445027,22.2518839 L34.7445027,22.219215 Z\" id=\"Shape\"></path></g></g></g></svg>"

/***/ }),

/***/ 741:
/***/ (function(module, exports) {

module.exports = "<svg width=\"80px\" height=\"83px\" viewBox=\"0 0 80 83\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Карттой на сатйе</title><desc>Created with Sketch.</desc><g id=\"Карттой-на-сатйе\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Group-3\" transform=\"translate(10.000000, 3.000000)\"><path d=\"M55.0946691,44.1704545 L53.1948529,44.1704545 L53.1948529,39.7668523 C53.1948529,35.8414432 50.0354586,32.6477273 46.1522344,32.6477273 C42.6964687,32.6477273 39.7764513,35.1500795 39.2065064,38.5972955 L38.2869954,44.1704545 L5.69944853,44.1704545 C4.65075,44.1704545 3.79963235,43.3100909 3.79963235,42.25 L3.79963235,23.0454545 L56.9944853,23.0454545 L56.9944853,42.25 C56.9944853,43.3100909 56.1433676,44.1704545 55.0946691,44.1704545 Z\" id=\"Path\" fill=\"#EB753F\"></path><g id=\"Group-2\" fill=\"#000000\" fill-rule=\"nonzero\"><g id=\"Group\"><path d=\"M60.7941176,42.25 L60.7941176,17.2840909 C60.7941176,14.1076591 58.2369651,11.5227273 55.0946691,11.5227273 L45.5955882,11.5227273 L45.5955882,9.60227273 C45.5955882,6.42584091 43.0384357,3.84090909 39.8961397,3.84090909 C39.1457123,3.84090909 38.4332813,3.99646591 37.7759449,4.26340909 C37.1205083,1.81482955 34.9243208,0 32.296875,0 C29.6694292,0 27.4751415,1.81482955 26.8178051,4.26340909 C26.1604688,3.99646591 25.4480377,3.84090909 24.6976103,3.84090909 C23.232852,3.84090909 21.9086801,4.41896591 20.8979779,5.33886364 C19.8872757,4.41704545 18.5631039,3.84090909 17.0983456,3.84090909 C13.9560496,3.84090909 11.3988971,6.42584091 11.3988971,9.60227273 L11.3988971,11.5227273 L5.69944853,11.5227273 C2.55715257,11.5227273 0,14.1076591 0,17.2840909 L0,42.25 C0,45.4264318 2.55715257,48.0113636 5.69944853,48.0113636 L9.49908088,48.0113636 L9.49908088,51.1493864 C9.49908088,53.1620227 9.96833548,55.1765795 10.8593493,56.9779659 L15.1985294,65.7486818 L15.1985294,78 L18.9981618,78 L18.9981618,64.8422273 L14.2581204,55.2610795 C13.6311811,53.9897386 13.2987132,52.5686023 13.2987132,51.1493864 L13.2987132,48.0113636 L41.505284,48.0113636 L42.9548438,39.229125 C43.2151186,37.6409091 44.5601884,36.4886364 46.1522344,36.4886364 C47.9399614,36.4886364 49.3952206,37.9597045 49.3952206,39.7668523 L49.3952206,51.7965795 C49.3952206,53.8745114 48.688489,55.9140341 47.4023134,57.5368182 L41.7959559,64.621375 L41.7959559,78 L45.5955882,78 L45.5955882,65.9695341 L50.3717261,59.9354659 C52.19175,57.6328409 53.1948529,54.7425568 53.1948529,51.7965795 L53.1948529,48.0113636 L55.0946691,48.0113636 C58.2369651,48.0113636 60.7941176,45.4264318 60.7941176,42.25 Z M39.8961397,7.68181818 C40.9448382,7.68181818 41.7959559,8.54410227 41.7959559,9.60227273 L41.7959559,11.5227273 L37.9963235,11.5227273 L37.9963235,9.60227273 C37.9963235,8.54410227 38.8474412,7.68181818 39.8961397,7.68181818 Z M30.3970588,5.76136364 C30.3970588,4.70319318 31.2481765,3.84090909 32.296875,3.84090909 C33.3455735,3.84090909 34.1966912,4.70319318 34.1966912,5.76136364 L34.1966912,9.60227273 L34.1966912,11.5227273 L30.3970588,11.5227273 L30.3970588,9.60227273 L30.3970588,5.76136364 Z M24.6976103,7.68181818 C25.7463088,7.68181818 26.5974265,8.54410227 26.5974265,9.60227273 L26.5974265,11.5227273 L22.7977941,11.5227273 L22.7977941,9.60227273 C22.7977941,8.54410227 23.6489118,7.68181818 24.6976103,7.68181818 Z M15.1985294,9.60227273 C15.1985294,8.54410227 16.0496471,7.68181818 17.0983456,7.68181818 C18.1470441,7.68181818 18.9981618,8.54410227 18.9981618,9.60227273 L18.9981618,11.5227273 L15.1985294,11.5227273 L15.1985294,9.60227273 Z M5.69944853,15.3636364 L55.0946691,15.3636364 C56.1433676,15.3636364 56.9944853,16.2259205 56.9944853,17.2840909 L56.9944853,19.2045455 L3.79963235,19.2045455 L3.79963235,17.2840909 C3.79963235,16.2259205 4.65075,15.3636364 5.69944853,15.3636364 Z M55.0946691,44.1704545 L53.1948529,44.1704545 L53.1948529,39.7668523 C53.1948529,35.8414432 50.0354586,32.6477273 46.1522344,32.6477273 C42.6964688,32.6477273 39.7764513,35.1500795 39.2065064,38.5972955 L38.2869954,44.1704545 L5.69944853,44.1704545 C4.65075,44.1704545 3.79963235,43.3100909 3.79963235,42.25 L3.79963235,23.0454545 L56.9944853,23.0454545 L56.9944853,42.25 C56.9944853,43.3100909 56.1433676,44.1704545 55.0946691,44.1704545 Z\" id=\"Shape\"></path><path d=\"M17.7272727,26.3823529 C16.771877,26.3823529 15.8146043,26.5911176 14.9117647,26.9885735 C14.0089251,26.5911176 13.0516524,26.3823529 12.0962567,26.3823529 C7.95558289,26.3823529 4.58823529,29.9835441 4.58823529,34.4117647 C4.58823529,38.8399853 7.95558289,42.4411765 12.0962567,42.4411765 C13.0516524,42.4411765 14.0089251,42.2324118 14.9117647,41.8329485 C15.8146043,42.2324118 16.771877,42.4411765 17.7272727,42.4411765 C21.8679465,42.4411765 25.2352941,38.8399853 25.2352941,34.4117647 C25.2352941,29.9835441 21.8679465,26.3823529 17.7272727,26.3823529 Z M17.7272727,38.4264706 C17.0834599,38.4264706 16.4546631,38.2377794 15.8577754,37.8644118 L14.9117647,37.2762574 L13.965754,37.8644118 C13.3688663,38.2377794 12.7400695,38.4264706 12.0962567,38.4264706 C10.0259198,38.4264706 8.34224599,36.625875 8.34224599,34.4117647 C8.34224599,32.1976544 10.0259198,30.3970588 12.0962567,30.3970588 C12.7400695,30.3970588 13.3688663,30.58575 13.965754,30.9591176 L14.9117647,31.5472721 L15.8577754,30.9591176 C16.4546631,30.58575 17.0834599,30.3970588 17.7272727,30.3970588 C19.7976096,30.3970588 21.4812834,32.1976544 21.4812834,34.4117647 C21.4812834,36.625875 19.7976096,38.4264706 17.7272727,38.4264706 Z\" id=\"Shape\"></path></g></g></g></g></svg>"

/***/ }),

/***/ 742:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Restaurants_vue_vue_type_template_id_5c8b8d53___ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Restaurants_vue_vue_type_script_lang_js___ = __webpack_require__(309);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Restaurants_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Restaurants_vue_vue_type_template_id_5c8b8d53___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Restaurants_vue_vue_type_template_id_5c8b8d53___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 743:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Restaurants_vue_vue_type_template_id_5c8b8d53___ = __webpack_require__(744);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Restaurants_vue_vue_type_template_id_5c8b8d53___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Restaurants_vue_vue_type_template_id_5c8b8d53___["b"]; });


/***/ }),

/***/ 744:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"restaurants"}},[_c('div',{staticClass:"adaptive-column-content"},[(!_vm.isSmartphone)?_c('h2',[_vm._v("Наши рестораны")]):_vm._e(),_vm._v(" "),(_vm.restaurants.length === 0)?_c('content-loader',{attrs:{"title":"Пожалуйста, подождите, мы загружаем рестораны"}}):_vm._l((_vm.restaurants),function(restaurant){return _c('restaurant',{key:restaurant.id,attrs:{"restaurant":restaurant}})})],2)])}
var staticRenderFns = []



/***/ }),

/***/ 745:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Restaurant_vue_vue_type_template_id_609e2f86___ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Restaurant_vue_vue_type_script_lang_js___ = __webpack_require__(312);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Restaurant_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Restaurant_vue_vue_type_template_id_609e2f86___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Restaurant_vue_vue_type_template_id_609e2f86___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 746:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Restaurant_vue_vue_type_template_id_609e2f86___ = __webpack_require__(747);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Restaurant_vue_vue_type_template_id_609e2f86___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Restaurant_vue_vue_type_template_id_609e2f86___["b"]; });


/***/ }),

/***/ 747:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"restaurant"},[(_vm.isSmartphone)?_c('div',{staticClass:"smartphone-titles"},[_c('h3',[_vm._v(_vm._s(_vm.restaurant.title.rendered))]),_vm._v(" "),(_vm.restaurant.acf.subtitle)?_c('h4',[_vm._v(_vm._s(_vm.restaurant.acf.subtitle))]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"photo-column"},[_c('img',{attrs:{"src":_vm.restaurant.acf.photo}})]),_vm._v(" "),_c('div',{staticClass:"content-column"},[(!_vm.isSmartphone)?[_c('h3',[_vm._v(_vm._s(_vm.restaurant.title.rendered))]),_vm._v(" "),(_vm.restaurant.acf.subtitle)?_c('h4',[_vm._v(_vm._s(_vm.restaurant.acf.subtitle))]):_vm._e()]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"properties"},[_c('div',[_c('div',{staticClass:"property"},[_c('div',{staticClass:"title"},[_vm._v("Адрес")]),_vm._v(" "),_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.address)}})]),_vm._v(" "),_c('div',{staticClass:"property"},[_c('div',{staticClass:"title"},[_vm._v("Телефон")]),_vm._v(" "),_c('div',{staticClass:"text"},[_c('phone',{attrs:{"phone":_vm.restaurant.acf.phone}})],1)])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"property"},[_c('div',{staticClass:"title"},[_vm._v("Метро")]),_vm._v(" "),_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.metro)}})]),_vm._v(" "),_c('div',{staticClass:"property"},[_c('div',{staticClass:"title"},[_vm._v("Часы работы")]),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.restaurant.acf.time))])])])]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.restaurant.acf.description))]),_vm._v(" "),_c('div',{staticClass:"actions"},[(_vm.restaurant.acf.menus.length > 1)?_c('div',{staticClass:"menu-button-container"},[_c('div',{staticClass:"button menu",on:{"click":_vm.openMenuPopoverOptions}},[_c('svg-inline',{attrs:{"src":__webpack_require__(311)}}),_vm._v(" "),_c('span',[_vm._v("Смотреть меню")])],1),_vm._v(" "),_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hideMenuPopoverOptions),expression:"hideMenuPopoverOptions"}],staticClass:"menu-popover-options",class:{ 'shown': _vm.menuPopoverOptionsShown }},_vm._l((_vm.restaurant.acf.menus),function(menu,index){return _c('a',{key:index,attrs:{"target":"_blank","href":menu.file},on:{"click":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"force",undefined,$event.key,undefined)){ return null; }return _vm.hideMenuPopoverOptions($event)}}},[_vm._v(_vm._s(menu.title))])}),0)]):_c('div',{staticClass:"menu-button-container"},[_c('a',{staticClass:"button menu",attrs:{"target":"_blank","href":_vm.restaurant.acf.menus[0].file}},[_c('svg-inline',{attrs:{"src":__webpack_require__(311)}}),_vm._v(" "),_c('span',[_vm._v("Смотреть меню")])],1)]),_vm._v(" "),_c('router-link',{staticClass:"red button reserve-table",attrs:{"to":{ name: 'ReserveTable', params: { restaurant: _vm.restaurant.slug } }}},[_vm._v("Заказать столик")])],1)],2)])}
var staticRenderFns = []



/***/ }),

/***/ 748:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Phone_vue_vue_type_template_id_22e63874___ = __webpack_require__(749);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Phone_vue_vue_type_template_id_22e63874___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Phone_vue_vue_type_template_id_22e63874___["b"]; });


/***/ }),

/***/ 749:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"phone",attrs:{"href":'tel:' + _vm.telLink}},[_vm._v(_vm._s(_vm._f("formatted")(_vm.phone)))])}
var staticRenderFns = []



/***/ }),

/***/ 750:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Order_vue_vue_type_template_id_485419a4___ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Order_vue_vue_type_script_lang_js___ = __webpack_require__(317);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Order_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__Order_vue_vue_type_template_id_485419a4___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Order_vue_vue_type_template_id_485419a4___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 751:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Order_vue_vue_type_template_id_485419a4___ = __webpack_require__(752);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Order_vue_vue_type_template_id_485419a4___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Order_vue_vue_type_template_id_485419a4___["b"]; });


/***/ }),

/***/ 752:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"order"}},[_c('div',{staticClass:"adaptive-column-content"},[_c('h2',{staticClass:"main"},[_vm._v(_vm._s(_vm.isSmartphone ? 'Корзина' : 'Оформление заказа'))]),_vm._v(" "),(!_vm.menuLoaded)?_c('content-loader',{attrs:{"title":"Пожалуйста, подождите, мы загружаем Ваш заказ"}}):[(_vm.isSmartphone)?_c('narrow-cart',{attrs:{"promotionsGifts":_vm.form.promotionsGifts}}):[_c('div',{staticClass:"desktop-items"},[_vm._l((_vm.cartLinesWithData),function(line,index){return _c('div',{key:index,staticClass:"cart-item"},[_c('div',{staticClass:"image",class:{ 'use-contain': line.dish.image_use_contain },style:({'background-image': ("url('" + (_vm.image(line.dish.image)) + "')")})}),_vm._v(" "),_c('div',{staticClass:"info"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(line.dish.post_title)+", "),_c('span',{staticClass:"size"},[_vm._v(_vm._s(line.dish.size))])]),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(line.dish.desc))])]),_vm._v(" "),_c('quantity-selector',{attrs:{"amount":line.quantity},on:{"clickMinus":function($event){return _vm.removeFromCart(line.id)},"clickPlus":function($event){return _vm.addToCart(line.id)}}}),_vm._v(" "),_c('div',{staticClass:"price-cont"},[_c('div',{staticClass:"price"},[_vm._v(_vm._s(_vm._f("money")((+line.dish.price - +line.dish.discount) * line.quantity))+" "),_c('rub')],1),_vm._v(" "),(line.dish.discount)?_c('div',{staticClass:"crossed-price"},[_vm._v(_vm._s(_vm._f("money")(+line.dish.price * line.quantity))+" "),_c('rub')],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"remove-button",on:{"click":function($event){return _vm.removeLineFromCart(line.id)}}},[_c('svg-inline',{attrs:{"src":__webpack_require__(316)}})],1)],1)}),_vm._v(" "),_vm._l((_vm.form.promotionsGifts),function(dish,promotionId){return _c('div',{key:promotionId,staticClass:"cart-item"},[_c('div',{staticClass:"image",class:{ 'use-contain': dish.image_use_contain },style:({'background-image': ("url('" + (_vm.image(dish.image)) + "')")})}),_vm._v(" "),_c('div',{staticClass:"info"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(dish.post_title)+", "),_c('span',{staticClass:"size"},[_vm._v(_vm._s(dish.size))])]),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(dish.desc))])]),_vm._v(" "),_c('div',{staticClass:"quantity-selector-mock"}),_vm._v(" "),_c('div',{staticClass:"price-cont"},[_c('div',{staticClass:"gift-icon"},[_c('svg-inline',{attrs:{"src":__webpack_require__(193)}})],1),_vm._v(" "),_c('div',{staticClass:"crossed-price"},[_vm._v(_vm._s(_vm._f("money")(+dish.price))+" "),_c('rub')],1)]),_vm._v(" "),_c('div',{staticClass:"remove-button-mock"})])})],2),_vm._v(" "),_c('div',{staticClass:"desktop-items-delivery-line"},[(_vm.totalSum >= 1400)?[_c('div',{staticClass:"label"},[_vm._v("Доставка:")]),_vm._v(" "),_c('div',{staticClass:"price"},[_vm._v("бесплатно")])]:(_vm.totalSum >= 1200)?[_c('div',{staticClass:"label"},[_vm._v("Доставка:")]),_vm._v(" "),_c('div',{staticClass:"price"},[_vm._v("бесплатно для "),_c('router-link',{attrs:{"to":{ name: 'Conditions' }}},[_vm._v("зон 1 и 2")])],1)]:(_vm.totalSum >= 800)?[_c('div',{staticClass:"label"},[_vm._v("Доставка:")]),_vm._v(" "),_c('div',{staticClass:"price"},[_vm._v("бесплатно для "),_c('router-link',{attrs:{"to":{ name: 'Conditions' }}},[_vm._v("зоны 1")])],1)]:[_c('div',{staticClass:"message"},[_vm._v("Минимальная сумма заказа составляет 800 "),_c('rub'),_vm._v(", пожалуйста, добавьте что-то ещё.")],1)]],2),_vm._v(" "),_c('div',{staticClass:"desktop-items-total-line"},[_c('div',{staticClass:"label"},[_vm._v("Сумма заказа:")]),_vm._v(" "),(_vm.cartHasDiscount)?_c('div',{staticClass:"crossed-price"},[_vm._v(_vm._s(_vm._f("money")(_vm.totalSumBeforeDiscount))+" "),_c('rub')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"price"},[_vm._v(_vm._s(_vm._f("money")(_vm.totalSum))+" "),_c('rub')],1)])],_vm._v(" "),(_vm.availableGiftsByPromotions.length > 0)?[_c('h2',{staticClass:"gifts"},[_vm._v("Заберите "+_vm._s(_vm.availableGiftsByPromotions.length > 1 ? 'подарки' : 'подарок')+"!")]),_vm._v(" "),_vm._l((_vm.availableGiftsByPromotions),function(giftPromotionData){return _c('div',{staticClass:"gift-promotion"},[_c('div',{staticClass:"options"},[(!_vm.isSmartphone)?_vm._l((giftPromotionData.dishes),function(dish,index){return _c('div',{staticClass:"option",class:{ 'inactive': dish.needSum }},[_c('dish',{attrs:{"dish":dish,"giftMode":true,"giftSelected":_vm.form.promotionsGifts[giftPromotionData.id] && _vm.form.promotionsGifts[giftPromotionData.id].ID === dish.ID},on:{"selectGift":function($event){return _vm.$set(_vm.form.promotionsGifts, giftPromotionData.id, dish)}}}),_vm._v(" "),(dish.needSum)?_c('div',{staticClass:"min-sum-mark"},[_vm._v("Нужно заказать на "+_vm._s(dish.needSum)+" "),_c('rub')],1):_vm._e()],1)}):_c('gift-dishes-swiper',{attrs:{"promotionsGifts":_vm.form.promotionsGifts,"giftPromotionData":giftPromotionData},on:{"selectGift":function (dish) { _vm.$set(_vm.form.promotionsGifts, giftPromotionData.id, dish) }}})],2)])})]:_vm._e(),_vm._v(" "),_c('h2',{staticClass:"form"},[_vm._v("Доставка и оплата")]),_vm._v(" "),_c('form',{attrs:{"id":"order-form"}},[_c('div',{staticClass:"delivery-fields"},[_c('div',{staticClass:"row phone"},[_c('input-container',{class:{ 'has-error': _vm.$v.form.phone.$error },attrs:{"type":"tel","label":"Телефон","inputId":"phone","required":true},on:{"input":_vm.onPhoneInput},model:{value:(_vm.form.phone),callback:function ($$v) {_vm.$set(_vm.form, "phone", $$v)},expression:"form.phone"}}),_vm._v(" "),_c('input-container',{class:{ 'has-error': _vm.$v.form.people.$error },attrs:{"type":"number","label":"Приборы","inputId":"people","required":true},model:{value:(_vm.form.people),callback:function ($$v) {_vm.$set(_vm.form, "people", $$v)},expression:"form.people"}})],1),_vm._v(" "),_c('input-container',{class:{ 'has-error': _vm.$v.form.name.$error },attrs:{"label":"Имя","inputId":"name","required":true},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}}),_vm._v(" "),_c('div',{staticClass:"row address"},[_c('input-container',{class:{ 'has-error': _vm.$v.form.streetHouse.$error },attrs:{"label":"Улица, дом","inputId":"street-house","required":true},model:{value:(_vm.form.streetHouse),callback:function ($$v) {_vm.$set(_vm.form, "streetHouse", $$v)},expression:"form.streetHouse"}}),_vm._v(" "),_c('input-container',{attrs:{"label":"Квартира","inputId":"flat"},model:{value:(_vm.form.flat),callback:function ($$v) {_vm.$set(_vm.form, "flat", $$v)},expression:"form.flat"}})],1),_vm._v(" "),_c('input-container',{attrs:{"type":"textarea","label":"Комментарий к доставке","inputId":"comment"},model:{value:(_vm.form.comment),callback:function ($$v) {_vm.$set(_vm.form, "comment", $$v)},expression:"form.comment"}})],1),_vm._v(" "),_c('div',{staticClass:"hor-line"}),_vm._v(" "),_c('div',{staticClass:"payment-fields"},[_c('input-container',{attrs:{"type":"select","label":"Способ оплаты","inputId":"payment-method","selectOptions":_vm.paymentMethods},model:{value:(_vm.form.paymentMethod),callback:function ($$v) {_vm.$set(_vm.form, "paymentMethod", $$v)},expression:"form.paymentMethod"}}),_vm._v(" "),(_vm.form.paymentMethod.code === 'cash' && !_vm.noCashChange)?_c('input-container',{attrs:{"type":"number","label":"Сдача с","inputId":"cashChange","required":true},model:{value:(_vm.form.cashChange),callback:function ($$v) {_vm.$set(_vm.form, "cashChange", $$v)},expression:"form.cashChange"}}):_vm._e(),_vm._v(" "),(_vm.form.paymentMethod.code === 'cash')?_c('input-container',{attrs:{"type":"checkbox","label":"Без сдачи","inputId":"noCashChange"},model:{value:(_vm.noCashChange),callback:function ($$v) {_vm.noCashChange=$$v},expression:"noCashChange"}}):_vm._e()],1),_vm._v(" "),(!_vm.isSmartphone)?_c('div',{staticClass:"final-row"},[_c('div',{staticClass:"label"},[_vm._v("К оплате")]),_vm._v(" "),(_vm.cartHasDiscount)?_c('div',{staticClass:"crossed-price"},[_vm._v(_vm._s(_vm._f("money")(_vm.totalSumBeforeDiscount))+" "),_c('rub')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"price"},[_vm._v(_vm._s(_vm._f("money")(_vm.totalSum))+" "),_c('rub')],1),_vm._v(" "),_c('mangal-button',{staticClass:"red",class:{ 'disabled': _vm.totalSum < 800 },attrs:{"loading":_vm.isLoading,"text":"Оформить заказ"},nativeOn:{"click":function($event){return _vm.processSubmit($event)}}})],1):[_c('div',{staticClass:"total-line"},[_c('div',{staticClass:"label"},[_vm._v("Сумма заказа:")]),_vm._v(" "),(_vm.cartHasDiscount)?_c('div',{staticClass:"crossed-price"},[_vm._v(_vm._s(_vm._f("money")(_vm.totalSumBeforeDiscount))+" "),_c('rub')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"price"},[_vm._v(_vm._s(_vm._f("money")(_vm.totalSum))+" "),_c('rub')],1)]),_vm._v(" "),_c('mangal-button',{staticClass:"red",class:{ 'disabled': _vm.totalSum < 800 },attrs:{"loading":_vm.isLoading,"text":"Оформить заказ"},nativeOn:{"click":function($event){return _vm.processSubmit($event)}}})],_vm._v(" "),(_vm.createOrderFailed)?_c('div',{staticClass:"error-message"},[_vm._v("Извините, произошла ошибка при попытке создать заказ. Мы уже занимаемся решением данной проблемы. Пожалуйста, позвоните нам по номеру "),_c('phone'),_vm._v(", чтобы мы могли помочь Вам оформить заказ!")],1):_vm._e()],2)]],2)])}
var staticRenderFns = []



/***/ }),

/***/ 753:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_InputContainer_vue_vue_type_template_id_5d399475___ = __webpack_require__(754);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_InputContainer_vue_vue_type_template_id_5d399475___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_InputContainer_vue_vue_type_template_id_5d399475___["b"]; });


/***/ }),

/***/ 754:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-container",attrs:{"data-name":_vm.inputId}},[(_vm.type === 'checkbox')?_c('input',{attrs:{"type":"checkbox","id":_vm.inputId},domProps:{"value":_vm.value},on:{"input":_vm.processInput}}):_vm._e(),_c('label',{attrs:{"for":_vm.inputId}},[_vm._v(_vm._s(_vm.label)+_vm._s(_vm.required ? '*' : ''))]),_vm._v(" "),(_vm.type === 'text')?_c('input',{attrs:{"type":"text","id":_vm.inputId},domProps:{"value":_vm.value},on:{"input":_vm.processInput}}):(_vm.type === 'tel')?_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('+7 (###) ###-##-##'),expression:"'+7 (###) ###-##-##'"}],attrs:{"type":"tel","id":_vm.inputId},domProps:{"value":_vm.value},on:{"input":_vm.processInput}}):(_vm.type === 'number')?_c('input',{attrs:{"type":"number","id":_vm.inputId,"min":"0"},domProps:{"value":_vm.value},on:{"input":_vm.processInput}}):(_vm.type === 'textarea')?_c('textarea',{attrs:{"id":_vm.inputId},domProps:{"value":_vm.value},on:{"input":_vm.processInput}}):(_vm.type === 'select')?_c('select-input',{attrs:{"inputId":_vm.inputId,"value":_vm.value,"options":_vm.selectOptions},on:{"input":_vm.processInput}}):_vm._e()],1)}
var staticRenderFns = []



/***/ }),

/***/ 755:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SelectInput_vue_vue_type_template_id_6bfe22a4___ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SelectInput_vue_vue_type_script_lang_js___ = __webpack_require__(322);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SelectInput_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__SelectInput_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__SelectInput_vue_vue_type_template_id_6bfe22a4___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SelectInput_vue_vue_type_template_id_6bfe22a4___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 756:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SelectInput_vue_vue_type_template_id_6bfe22a4___ = __webpack_require__(757);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SelectInput_vue_vue_type_template_id_6bfe22a4___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SelectInput_vue_vue_type_template_id_6bfe22a4___["b"]; });


/***/ }),

/***/ 757:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-container"},[_c('v-select',{attrs:{"value":_vm.value,"id":_vm.inputId,"options":_vm.options,"searchable":false,"clearable":false,"components":{OpenIndicator: _vm.OpenIndicator}},on:{"input":_vm.processInput}})],1)}
var staticRenderFns = []



/***/ }),

/***/ 758:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_12_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_12_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_3_node_modules_sass_loader_lib_loader_js_ref_12_4_node_modules_vue_loader_lib_index_js_vue_loader_options_SelectInput_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_12_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_12_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_3_node_modules_sass_loader_lib_loader_js_ref_12_4_node_modules_vue_loader_lib_index_js_vue_loader_options_SelectInput_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_12_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_12_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_3_node_modules_sass_loader_lib_loader_js_ref_12_4_node_modules_vue_loader_lib_index_js_vue_loader_options_SelectInput_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_12_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_12_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_3_node_modules_sass_loader_lib_loader_js_ref_12_4_node_modules_vue_loader_lib_index_js_vue_loader_options_SelectInput_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),

/***/ 760:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MangalButton_vue_vue_type_template_id_5dcbecf6___ = __webpack_require__(761);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MangalButton_vue_vue_type_template_id_5dcbecf6___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MangalButton_vue_vue_type_template_id_5dcbecf6___["b"]; });


/***/ }),

/***/ 761:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button",class:{ 'loading': _vm.loading }},[(!_vm.loading)?[_vm._v(_vm._s(_vm.text))]:_c('div',{staticClass:"loader"},[_c('div'),_c('div'),_c('div'),_c('div')])],2)}
var staticRenderFns = []



/***/ }),

/***/ 762:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_NarrowCart_vue_vue_type_template_id_0a727c56___ = __webpack_require__(763);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_NarrowCart_vue_vue_type_template_id_0a727c56___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_NarrowCart_vue_vue_type_template_id_0a727c56___["b"]; });


/***/ }),

/***/ 763:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"narrow-cart"},[_c('div',{staticClass:"items"},[_vm._l((_vm.cartLinesWithData),function(line,index){return _c('div',{key:index,staticClass:"cart-item"},[_c('div',{staticClass:"left-column"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(line.dish.post_title)+", "),_c('span',{staticClass:"size"},[_vm._v(_vm._s(line.dish.size))])]),_vm._v(" "),_c('div',{staticClass:"price-cont"},[_c('div',{staticClass:"price",domProps:{"innerHTML":_vm._s(_vm.priceInnerHTML(line))}}),_vm._v(" "),(+line.dish.discount)?_c('div',{staticClass:"crossed-price",domProps:{"innerHTML":_vm._s(_vm.crossedPriceInnerHTML(line))}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"right-column"},[_c('div',{staticClass:"remove-button",on:{"click":function($event){return _vm.removeLineFromCart(line.id)}}},[_c('svg-inline',{attrs:{"src":__webpack_require__(316)}})],1),_vm._v(" "),_c('quantity-selector',{staticClass:"small",attrs:{"amount":line.quantity},on:{"clickMinus":function($event){return _vm.removeFromCart(line.id)},"clickPlus":function($event){return _vm.addToCart(line.id)}}})],1)])}),_vm._v(" "),_vm._l((_vm.promotionsGifts),function(dish,promotionId){return _c('div',{key:promotionId,staticClass:"cart-item"},[_c('div',{staticClass:"left-column"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(dish.post_title)+", "),_c('span',{staticClass:"size"},[_vm._v(_vm._s(dish.size))])])]),_vm._v(" "),_c('div',{staticClass:"right-column gift"},[_c('div',{staticClass:"price-cont"},[_c('div',{staticClass:"gift-icon"},[_c('svg-inline',{attrs:{"src":__webpack_require__(193)}})],1),_vm._v(" "),_c('div',{staticClass:"crossed-price"},[_vm._v(_vm._s(_vm._f("money")(+dish.price))+" "),_c('rub')],1)])])])})],2),_vm._v(" "),_c('div',{staticClass:"thin-line"}),_vm._v(" "),_c('div',{staticClass:"delivery-line"},[(_vm.totalSum >= 1400)?[_c('div',{staticClass:"label"},[_vm._v("Доставка:")]),_vm._v(" "),_c('div',{staticClass:"price"},[_vm._v("бесплатно")])]:(_vm.totalSum >= 1200)?[_c('div',{staticClass:"label"},[_vm._v("Доставка:")]),_vm._v(" "),_c('div',{staticClass:"price"},[_vm._v("бесплатно для "),_c('router-link',{attrs:{"to":{ name: 'Conditions' }}},[_vm._v("зон 1 и 2")])],1)]:(_vm.totalSum >= 800)?[_c('div',{staticClass:"label"},[_vm._v("Доставка:")]),_vm._v(" "),_c('div',{staticClass:"price"},[_vm._v("бесплатно для "),_c('router-link',{attrs:{"to":{ name: 'Conditions' }}},[_vm._v("зоны 1")])],1)]:[_c('div',{staticClass:"message"},[_vm._v("Минимальная сумма заказа составляет 800 "),_c('rub'),_vm._v(", пожалуйста, добавьте что-то ещё.")],1)]],2),_vm._v(" "),_c('div',{staticClass:"total-line"},[_c('div',{staticClass:"label"},[_vm._v("Сумма заказа:")]),_vm._v(" "),(_vm.totalSumBeforeDiscount !== _vm.totalSum)?_c('div',{staticClass:"crossed-price"},[_vm._v(_vm._s(_vm._f("money")(_vm.totalSumBeforeDiscount))+" "),_c('rub')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"price"},[_vm._v(_vm._s(_vm._f("money")(_vm.totalSum))+" "),_c('rub')],1)]),_vm._v(" "),(!_vm.isSmartphone && _vm.totalSum >= 800)?_c('div',{staticClass:"gift-line"},[_vm._v("Перейдите к оформлению, чтобы выбрать подарок")]):_vm._e()])}
var staticRenderFns = []



/***/ }),

/***/ 764:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GiftDishesSwiper_vue_vue_type_template_id_30308205___ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GiftDishesSwiper_vue_vue_type_script_lang_js___ = __webpack_require__(330);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__GiftDishesSwiper_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__GiftDishesSwiper_vue_vue_type_template_id_30308205___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__GiftDishesSwiper_vue_vue_type_template_id_30308205___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 765:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GiftDishesSwiper_vue_vue_type_template_id_30308205___ = __webpack_require__(766);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GiftDishesSwiper_vue_vue_type_template_id_30308205___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GiftDishesSwiper_vue_vue_type_template_id_30308205___["b"]; });


/***/ }),

/***/ 766:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-dishes-swiper"},[_c('swiper',{ref:"mySwiper",staticClass:"dishes-slider",attrs:{"options":_vm.swiperOptions}},[_vm._l((_vm.giftPromotionData.dishes),function(dish,index){return _c('swiper-slide',{key:dish.ID},[_c('div',{staticClass:"option",class:{ 'inactive': dish.needSum }},[_c('dish',{attrs:{"dish":dish,"giftMode":true,"giftSelected":_vm.promotionsGifts[_vm.giftPromotionData.id] && _vm.promotionsGifts[_vm.giftPromotionData.id].ID === dish.ID},on:{"selectGift":function($event){return _vm.$emit('selectGift', dish)}}}),_vm._v(" "),(dish.needSum)?_c('div',{staticClass:"min-sum-mark"},[_vm._v("Нужно заказать на "+_vm._s(dish.needSum)+" "),_c('rub')],1):_vm._e()],1)])}),_vm._v(" "),_c('div',{staticClass:"dishes-slider-pagination",attrs:{"slot":"pagination"},slot:"pagination"})],2)],1)}
var staticRenderFns = []



/***/ }),

/***/ 786:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SuccessPage_vue_vue_type_template_id_6742b389___ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SuccessPage_vue_vue_type_script_lang_js___ = __webpack_require__(333);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__SuccessPage_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__SuccessPage_vue_vue_type_template_id_6742b389___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SuccessPage_vue_vue_type_template_id_6742b389___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 787:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SuccessPage_vue_vue_type_template_id_6742b389___ = __webpack_require__(788);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SuccessPage_vue_vue_type_template_id_6742b389___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SuccessPage_vue_vue_type_template_id_6742b389___["b"]; });


/***/ }),

/***/ 788:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"success-page"}},[_c('div',{staticClass:"adaptive-column-content"},[_c('div',{staticClass:"final-block-flex"},[_c('div',{staticClass:"text"},[_c('div',{staticClass:"title"},[_vm._v("Отлично,"),_c('br'),_vm._v(_vm._s(_vm.titleText))]),_vm._v(" "),_c('div',{staticClass:"subtitle",domProps:{"innerHTML":_vm._s(_vm.subtitleText)}})]),_vm._v(" "),_vm._m(0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image"},[_c('div',{staticClass:"text"},[_vm._v("\n          Приятного"),_c('br'),_vm._v("аппетита\n        ")])])}]



/***/ }),

/***/ 789:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReserveTable_vue_vue_type_template_id_29a6c779___ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ReserveTable_vue_vue_type_script_lang_js___ = __webpack_require__(335);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ReserveTable_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__ReserveTable_vue_vue_type_template_id_29a6c779___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ReserveTable_vue_vue_type_template_id_29a6c779___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 790:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ReserveTable_vue_vue_type_template_id_29a6c779___ = __webpack_require__(791);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ReserveTable_vue_vue_type_template_id_29a6c779___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ReserveTable_vue_vue_type_template_id_29a6c779___["b"]; });


/***/ }),

/***/ 791:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"reserve-table"}},[_c('div',{staticClass:"adaptive-column-content"},[(_vm.restaurants.length === 0)?_c('content-loader',{attrs:{"title":"Пожалуйста, подождите, мы загружаем информацию о ресторане"}}):[_c('h2',{staticClass:"form"},[_vm._v("Бронирование столика на "+_vm._s(_vm.restaurant.acf.short_address))]),_vm._v(" "),_c('form',{attrs:{"id":"order-form"}},[_c('div',{staticClass:"delivery-fields"},[_c('div',{staticClass:"row phone"},[_c('input-container',{class:{ 'has-error': _vm.$v.form.phone.$error },attrs:{"type":"tel","label":"Телефон","inputId":"phone","required":true},on:{"input":_vm.onPhoneInput},model:{value:(_vm.form.phone),callback:function ($$v) {_vm.$set(_vm.form, "phone", $$v)},expression:"form.phone"}}),_vm._v(" "),_c('input-container',{class:{ 'has-error': _vm.$v.form.people.$error },attrs:{"type":"number","label":"Число персон","inputId":"people","required":true},model:{value:(_vm.form.people),callback:function ($$v) {_vm.$set(_vm.form, "people", $$v)},expression:"form.people"}})],1),_vm._v(" "),_c('input-container',{class:{ 'has-error': _vm.$v.form.name.$error },attrs:{"label":"Имя","inputId":"name","required":true},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}}),_vm._v(" "),_c('input-container',{attrs:{"type":"textarea","label":"Комментарий","inputId":"comment"},model:{value:(_vm.form.comment),callback:function ($$v) {_vm.$set(_vm.form, "comment", $$v)},expression:"form.comment"}})],1),_vm._v(" "),_c('mangal-button',{staticClass:"red",attrs:{"loading":_vm.isLoading,"text":"Забронировать"},nativeOn:{"click":function($event){return _vm.processSubmit($event)}}}),_vm._v(" "),(_vm.reserveFailed)?_c('div',{staticClass:"error-message"},[_vm._v("Извините, произошла ошибка при попытке забронировать столик. Мы уже занимаемся решением данной проблемы. Пожалуйста, позвоните нам по номеру "),_c('phone'),_vm._v(", чтобы мы могли помочь Вам!")],1):_vm._e()],1)]],2)])}
var staticRenderFns = []



/***/ }),

/***/ 792:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SlideGen_vue_vue_type_template_id_2b891362_scoped_true___ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SlideGen_vue_vue_type_script_lang_js___ = __webpack_require__(337);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SlideGen_vue_vue_type_style_index_0_id_2b891362_lang_scss_scoped_true___ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(5);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__SlideGen_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__SlideGen_vue_vue_type_template_id_2b891362_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SlideGen_vue_vue_type_template_id_2b891362_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "2b891362",
  null
  
)

/* unused harmony default export */ var _unused_webpack_default_export = (component.exports);

/***/ }),

/***/ 793:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SlideGen_vue_vue_type_template_id_2b891362_scoped_true___ = __webpack_require__(794);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SlideGen_vue_vue_type_template_id_2b891362_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SlideGen_vue_vue_type_template_id_2b891362_scoped_true___["b"]; });


/***/ }),

/***/ 794:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slide",style:('background-image: url(\'' + __webpack_require__(795) + '\');')},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"gift"},[_vm._v("в подарок")]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v("При заказе от 1000 ₽ Вы можете выбрать «Цезарь с курицей гриль»,"),(!_vm.isSmartphone)?_c('br'):void 0,_vm._v("от 1300 ₽ «Пирог по-осетински» и от 1500 ₽ «Люля-кебаб из телятины»")],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_vm._v("Два горячих блюда"),_c('br'),_vm._v("или салат на выбор")])}]



/***/ }),

/***/ 795:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/banner2.7c8b6b2.jpg";

/***/ }),

/***/ 796:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_12_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_12_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_3_node_modules_sass_loader_lib_loader_js_ref_12_4_node_modules_vue_loader_lib_index_js_vue_loader_options_SlideGen_vue_vue_type_style_index_0_id_2b891362_lang_scss_scoped_true___ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_12_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_12_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_3_node_modules_sass_loader_lib_loader_js_ref_12_4_node_modules_vue_loader_lib_index_js_vue_loader_options_SlideGen_vue_vue_type_style_index_0_id_2b891362_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_12_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_12_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_3_node_modules_sass_loader_lib_loader_js_ref_12_4_node_modules_vue_loader_lib_index_js_vue_loader_options_SlideGen_vue_vue_type_style_index_0_id_2b891362_lang_scss_scoped_true___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_12_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_ref_12_2_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_3_node_modules_sass_loader_lib_loader_js_ref_12_4_node_modules_vue_loader_lib_index_js_vue_loader_options_SlideGen_vue_vue_type_style_index_0_id_2b891362_lang_scss_scoped_true____default.a); 

/***/ }),

/***/ 797:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getters__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_store_modules_menu__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_store_modules_cart__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_store_modules_content__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_store_modules_gtm__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_store_modules_marketing__ = __webpack_require__(879);







// import types from '/src/store/types'

// global modules






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
var debug = "production" !== 'production';

var state = {};

var mutations = {};

var inTwoHours = 1 / 12;

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  strict: debug,
  actions: __WEBPACK_IMPORTED_MODULE_4__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_5__getters__["a" /* default */],
  state: state,
  mutations: mutations,
  modules: {
    menu: __WEBPACK_IMPORTED_MODULE_6__src_store_modules_menu__["a" /* default */],
    cart: __WEBPACK_IMPORTED_MODULE_7__src_store_modules_cart__["a" /* default */],
    content: __WEBPACK_IMPORTED_MODULE_8__src_store_modules_content__["a" /* default */],
    gtm: __WEBPACK_IMPORTED_MODULE_9__src_store_modules_gtm__["a" /* default */],
    marketing: __WEBPACK_IMPORTED_MODULE_10__src_store_modules_marketing__["a" /* default */]
  },
  plugins: [__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate___default()({
    // storage: window.sessionStorage,
    storage: {
      getItem: function getItem(key) {
        return __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.get(key);
      },
      setItem: function setItem(key, value) {
        return __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.set(key, value, { expires: inTwoHours });
      },
      removeItem: function removeItem(key) {
        return __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.remove(key);
      }
    },
    paths: ['cart']
  })]
});

if (false) {
  window.store = store;
}

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 801:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(134);


// // import Raven from 'raven-js'
// import types from '/src/store/types'

/* harmony default export */ __webpack_exports__["a"] = ({
  reserveTable: function reserveTable(_ref, formData) {
    var commit = _ref.commit,
        getters = _ref.getters;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var requestData = {
        formData: formData,
        clientData: {}
      };

      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* api */].reserveTable(requestData).then(function (response) {
        resolve(response.body);
      }).catch(function (error) {
        console.log('error', error);
        reject(error);
      });
    });
  }
});

/***/ }),

/***/ 817:
/***/ (function(module, exports, __webpack_require__) {

var prodEnv = __webpack_require__(345);
var merge = __webpack_require__(818);

module.exports = merge(prodEnv, {
  NODE_ENV: '"development"',
  API_ROOT: 'https://mangalgril.ru',
  FRONT_URL: 'http://localhost:8082'
});

/***/ }),

/***/ 855:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 856:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_store_types__ = __webpack_require__(50);


var _mutations;

// import Vue from 'vue'




var state = {
  categories: [],
  dishes: []
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__src_store_types__["a" /* default */].menu.SET_CATEGORIES, function (state, categories) {
  state.categories = categories;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__src_store_types__["a" /* default */].menu.SET_DISHES, function (state, dishes) {
  state.dishes = dishes;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),

/***/ 857:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_cloneDeep__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_filter__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_pickBy__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_pickBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_pickBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_uniqBy__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_forEach__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_store_types__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(134);







// import Cookies from 'js-cookie'

// import { customizableParams, queryParamsRules, trialPricesMap, exponeaDimensions } from './config'
// import moment from 'moment'


/* harmony default export */ __webpack_exports__["a"] = ({
  loadCategories: function loadCategories(_ref) {
    var dispatch = _ref.dispatch,
        commit = _ref.commit;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* api */].loadCategories().then(function (response) {
        var mainCategories = {};

        __WEBPACK_IMPORTED_MODULE_5_lodash_forEach___default()(response.body, function (category) {
          if (category.parent === 0) {
            mainCategories[category.slug] = __WEBPACK_IMPORTED_MODULE_1_lodash_cloneDeep___default()(category);
            mainCategories[category.slug].acf.dishes = __WEBPACK_IMPORTED_MODULE_2_lodash_filter___default()(category.acf.dishes, function (x) {
              return !x.season_offer;
            });
          }
        });

        __WEBPACK_IMPORTED_MODULE_5_lodash_forEach___default()(mainCategories, function (parentCategory) {
          parentCategory.children = {};
          __WEBPACK_IMPORTED_MODULE_5_lodash_forEach___default()(response.body, function (category) {
            if (category.parent === parentCategory.id) {
              category.children = [];
              parentCategory.children[category.slug] = __WEBPACK_IMPORTED_MODULE_1_lodash_cloneDeep___default()(category);
              parentCategory.children[category.slug].acf.dishes = __WEBPACK_IMPORTED_MODULE_2_lodash_filter___default()(category.acf.dishes, function (x) {
                return !x.season_offer;
              });
              parentCategory.acf.dishes = parentCategory.acf.dishes.concat(category.acf.dishes);
            }
          });
          parentCategory.acf.dishes = __WEBPACK_IMPORTED_MODULE_4_lodash_uniqBy___default()(parentCategory.acf.dishes, function (dish) {
            return dish.ID;
          });
        });

        __WEBPACK_IMPORTED_MODULE_5_lodash_forEach___default()(mainCategories, function (parentCategory) {
          parentCategory.children = __WEBPACK_IMPORTED_MODULE_3_lodash_pickBy___default()(parentCategory.children, function (child) {
            return child.acf.dishes.length > 0;
          });
        });

        mainCategories = __WEBPACK_IMPORTED_MODULE_3_lodash_pickBy___default()(mainCategories, function (category) {
          return category.acf.dishes.length > 0;
        });

        commit(__WEBPACK_IMPORTED_MODULE_6__src_store_types__["a" /* default */].menu.SET_CATEGORIES, mainCategories);

        var allDishes = [];
        __WEBPACK_IMPORTED_MODULE_5_lodash_forEach___default()(response.body, function (category) {
          allDishes = allDishes.concat(category.acf.dishes);
        });
        allDishes = __WEBPACK_IMPORTED_MODULE_4_lodash_uniqBy___default()(allDishes, function (dish) {
          return dish.ID;
        });

        commit(__WEBPACK_IMPORTED_MODULE_6__src_store_types__["a" /* default */].menu.SET_DISHES, allDishes);

        dispatch('cart/clearRedundantDishes', {}, { root: true });

        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  }
});

/***/ }),

/***/ 862:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_differenceBy__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_differenceBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_differenceBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_forEach__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_cloneDeep__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_find__);




 // import { defaultRootConfigNode, processMainOfferDiscountConfig, calcComboDiscount } from './config'
// // import router from '/src/router'
// import DeviceDetector from '@/plugins/device-detector'
// import moment from 'moment'

var buildResidualByParent = function buildResidualByParent(parentCategory) {
  var residualDishes = __WEBPACK_IMPORTED_MODULE_3_lodash_cloneDeep___default()(parentCategory.acf.dishes);

  __WEBPACK_IMPORTED_MODULE_2_lodash_forEach___default()(parentCategory.children, function (subcategory) {
    residualDishes = __WEBPACK_IMPORTED_MODULE_1_lodash_differenceBy___default()(residualDishes, subcategory.acf.dishes, function (x) {
      return x.ID;
    });
  });

  if (residualDishes.length === 0) {
    return null;
  }

  return {
    acf: {
      dishes: residualDishes,
      icon: false
    },
    children: [],
    id: -1,
    parent: parentCategory,
    slug: 'other',
    title: {
      rendered: 'Без категории'
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  categories: function categories(state) {
    return state.categories;
  },
  dishes: function dishes(state) {
    return state.dishes;
  },
  currentCategory: function currentCategory(state, getters, rootState, rootGetters) {
    if (state.categories.length === 0) {
      return null;
    }
    var category = rootState.route.params.category;
    if (!category) {
      return null;
    }
    var subcategory = rootState.route.params.subcategory;
    if (!subcategory) {
      return state.categories[category];
    }

    if (subcategory === 'other') {
      return buildResidualByParent(state.categories[category]);
    }

    var res = __WEBPACK_IMPORTED_MODULE_3_lodash_cloneDeep___default()(state.categories[category].children[subcategory]);
    res.parent = state.categories[category];
    return res;
  },
  currentFirstLevelCategory: function currentFirstLevelCategory(state, getters) {
    if (!getters.currentCategory) {
      return getters.currentCategory;
    }

    return getters.currentCategory.parent || getters.currentCategory;
  },
  dishById: function dishById(state, getters, rootState, rootGetters) {
    return function (id) {
      return __WEBPACK_IMPORTED_MODULE_4_lodash_find___default()(getters.dishes, function (dish) {
        return dish.ID === id;
      });
    };
  },
  menuLoaded: function menuLoaded(state) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state.categories).length > 0;
  },
  residualSubcategory: function residualSubcategory(state, getters) {
    if (!getters.currentCategory.parent.id) {
      return null;
    }

    return buildResidualByParent(getters.currentCategory.parent);
  }
});

/***/ }),

/***/ 867:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_findIndex__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_store_types__ = __webpack_require__(50);



var _mutations;







var state = {
  cart: {
    lines: []
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__src_store_types__["a" /* default */].cart.ADD_ITEM, function (state, itemId) {
  var index = __WEBPACK_IMPORTED_MODULE_1_lodash_findIndex___default()(state.cart.lines, function (line) {
    return line.id === itemId;
  });

  if (index !== -1) {
    state.cart.lines[index].quantity++;
  } else {
    state.cart.lines.push({
      id: itemId,
      quantity: 1
    });
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__src_store_types__["a" /* default */].cart.REMOVE_ITEM, function (state, itemId) {
  var index = __WEBPACK_IMPORTED_MODULE_1_lodash_findIndex___default()(state.cart.lines, function (line) {
    return line.id === itemId;
  });

  if (index !== -1) {
    if (state.cart.lines[index].quantity > 1) {
      state.cart.lines[index].quantity--;
    } else {
      state.cart.lines.splice(index, 1);
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__src_store_types__["a" /* default */].cart.REMOVE_LINE, function (state, itemId) {
  var index = __WEBPACK_IMPORTED_MODULE_1_lodash_findIndex___default()(state.cart.lines, function (line) {
    return line.id === itemId;
  });

  if (index !== -1) {
    state.cart.lines.splice(index, 1);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__src_store_types__["a" /* default */].cart.CLEAR_CART, function (state) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.cart, 'lines', []);
  // Vue.set(state.cart, 'gifts', [])
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__["a" /* default */]
});

/***/ }),

/***/ 868:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_forEach__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_difference__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_difference___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_difference__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_map__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_cloneDeep__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_store_types__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_js_cookie__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(134);








// import moment from 'moment'


/* harmony default export */ __webpack_exports__["a"] = ({
  addToCart: function addToCart(_ref, dishId) {
    var commit = _ref.commit;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__src_store_types__["a" /* default */].cart.ADD_ITEM, dishId);
      resolve();
    });
  },
  removeFromCart: function removeFromCart(_ref2, dishId) {
    var commit = _ref2.commit;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__src_store_types__["a" /* default */].cart.REMOVE_ITEM, dishId);
      resolve();
    });
  },
  removeLineFromCart: function removeLineFromCart(_ref3, dishId) {
    var commit = _ref3.commit;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__src_store_types__["a" /* default */].cart.REMOVE_LINE, dishId);
      resolve();
    });
  },
  clearCart: function clearCart(_ref4) {
    var commit = _ref4.commit;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__src_store_types__["a" /* default */].cart.CLEAR_CART);
      resolve();
    });
  },
  clearRedundantDishes: function clearRedundantDishes(_ref5) {
    var rootGetters = _ref5.rootGetters,
        getters = _ref5.getters,
        commit = _ref5.commit;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function () {
      var cartIds = __WEBPACK_IMPORTED_MODULE_3_lodash_map___default()(getters.cart.lines, function (line) {
        return line.id;
      });
      var allIds = __WEBPACK_IMPORTED_MODULE_3_lodash_map___default()(rootGetters['menu/dishes'], function (dish) {
        return dish.ID;
      });
      var diff = __WEBPACK_IMPORTED_MODULE_2_lodash_difference___default()(cartIds, allIds);
      __WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default()(diff, function (id) {
        commit(__WEBPACK_IMPORTED_MODULE_5__src_store_types__["a" /* default */].cart.REMOVE_LINE, id);
      });
    });
  },
  createOrder: function createOrder(_ref6, formData) {
    var commit = _ref6.commit,
        getters = _ref6.getters,
        dispatch = _ref6.dispatch;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var newForm = __WEBPACK_IMPORTED_MODULE_4_lodash_cloneDeep___default()(formData);
      newForm.paymentMethod = formData.paymentMethod.code;
      if (newForm.paymentMethod !== 'cash') {
        delete newForm.cashChange;
      }

      var cookies = __WEBPACK_IMPORTED_MODULE_6_js_cookie___default.a.get();
      delete cookies.vuex;

      var requestData = {
        formData: newForm,
        cart: getters.cart.lines,
        clientData: {
          cookie: cookies
        },
        shopId: 1
      };

      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* api */].createOrder(requestData).then(function (response) {
        dispatch('gtm/sendSimpleEvent', { category: 'Conversions', action: 'CreateOrder' }, { root: true });
        resolve(response.body);
      }).catch(function (error) {
        console.log('error', error);
        reject(error);
      });
    });
  }
});

/***/ }),

/***/ 870:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_filter__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_sum__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_sum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_sum__);



 // import { defaultRootConfigNode, processMainOfferDiscountConfig, calcComboDiscount } from './config'
// // import router from '/src/router'
// import DeviceDetector from '@/plugins/device-detector'
// import moment from 'moment'

/* harmony default export */ __webpack_exports__["a"] = ({
  cart: function cart(state) {
    return state.cart;
  },
  cartLines: function cartLines(state, getters, rootState, rootGetters) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(getters.cart.lines, function (line) {
      return rootGetters['menu/dishById'](line.id);
    });
  },
  cartLinesWithData: function cartLinesWithData(state, getters, rootState, rootGetters) {
    return __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(getters.cartLines, function (line) {
      var dishData = rootGetters['menu/dishById'](line.id);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, line, { dish: dishData });
    });
  },
  totalSum: function totalSum(state, getters, rootState, rootGetters) {
    return __WEBPACK_IMPORTED_MODULE_3_lodash_sum___default()(__WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(getters.cartLines, function (line) {
      var dish = rootGetters['menu/dishById'](line.id);
      return (+dish.price - +dish.discount) * line.quantity;
    }));
  },
  totalSumBeforeDiscount: function totalSumBeforeDiscount(state, getters, rootState, rootGetters) {
    return __WEBPACK_IMPORTED_MODULE_3_lodash_sum___default()(__WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(getters.cartLines, function (line) {
      var dish = rootGetters['menu/dishById'](line.id);
      return +dish.price * line.quantity;
    }));
  },
  totalItems: function totalItems(state, getters) {
    return __WEBPACK_IMPORTED_MODULE_3_lodash_sum___default()(__WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(getters.cart.lines, function (line) {
      return line.quantity;
    }));
  },
  availableGiftsByPromotions: function availableGiftsByPromotions(state, getters, rootState, rootGetters) {
    var giftPromotions = __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(rootGetters['content/promotions'], function (promotion) {
      return promotion.acf.type === 'gifts';
    });

    return __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(giftPromotions, function (promotion) {
      // let availableRows = filter(promotion.acf.conditions, condition => parseInt(condition.min_sum) <= getters.totalSum)
      // let unavailableRows = filter(promotion.acf.conditions, condition => parseInt(condition.min_sum) > getters.totalSum)

      // let messageBullets = map(unavailableRows, row => 'При заказе от ' + row.min_sum + ' ₽ Вы можете выбрать «' + rootGetters['menu/dishById'](row.dish_id).post_title + '» в подарок')
      //
      // let mainMessage = ''
      // if (availableRows.length === 0) {
      //   mainMessage = 'Обратите внимание!'
      // } else if (unavailableRows.length !== 0) {
      //   mainMessage = 'Обратите внимание!'
      // } else {
      //   mainMessage = 'За заказ на сумму от ' + availableRows[availableRows.length - 1].min_sum + ' ₽ Вы можете выбрать любой подарок'
      // }

      return {
        id: promotion.id,
        dishes: __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(promotion.acf.conditions, function (condition) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rootGetters['menu/dishById'](condition.dish_id), { needSum: parseInt(condition.min_sum) > getters.totalSum ? parseInt(condition.min_sum) : null });
        })
        // mainMessage: mainMessage,
        // messageBullets: messageBullets
      };
    });
  }
});

/***/ }),

/***/ 873:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_store_types__ = __webpack_require__(50);


var _mutations;





var state = {
  promotions: [],
  restaurants: []
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__src_store_types__["a" /* default */].content.SET_PROMOTIONS, function (state, promotions) {
  state.promotions = promotions;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__src_store_types__["a" /* default */].content.SET_RESTAURANTS, function (state, restaurants) {
  state.restaurants = restaurants;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),

/***/ 874:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_store_types__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(134);


// import Cookies from 'js-cookie'
// import moment from 'moment'


/* harmony default export */ __webpack_exports__["a"] = ({
  loadPromotions: function loadPromotions(_ref) {
    var rootState = _ref.rootState,
        getters = _ref.getters,
        commit = _ref.commit;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* api */].loadPromotions().then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_1__src_store_types__["a" /* default */].content.SET_PROMOTIONS, response.body);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  loadRestaurants: function loadRestaurants(_ref2) {
    var rootState = _ref2.rootState,
        getters = _ref2.getters,
        commit = _ref2.commit;
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* api */].loadRestaurants().then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_1__src_store_types__["a" /* default */].content.SET_RESTAURANTS, response.body);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  }
});

/***/ }),

/***/ 875:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
// import { defaultRootConfigNode, processMainOfferDiscountConfig, calcComboDiscount } from './config'
// // import router from '/src/router'
// import DeviceDetector from '@/plugins/device-detector'
// import moment from 'moment'

/* harmony default export */ __webpack_exports__["a"] = ({
  restaurants: function restaurants(state) {
    return state.restaurants;
  },
  promotions: function promotions(state) {
    return state.promotions;
  }
});

/***/ }),

/***/ 876:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(878);



var state = {};

var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */]
});

/***/ }),

/***/ 877:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(48);




/* harmony default export */ __webpack_exports__["a"] = ({
  // productClick: ({ rootState, rootGetters }, data) => new Promise(() => {
  //   const menuType = data.menuType || rootGetters['menus/currentMenu'].type
  //   const pricePlan = rootGetters['menus/currentPricePlan']
  //   const city = rootState.cities.active
  //
  //   let price = rootGetters['menus/currentMenuPrice']
  //
  //   Vue.gtm.trackEvent({
  //     'event': 'product_click',
  //     'product_price': price,
  //     'product_menu_type': menuType,
  //     'product_meal_days': pricePlan.numberOfMealDays,
  //     'product_city_id': city.id
  //   })
  // }),
  // addToCart: ({ rootState, rootGetters }) => new Promise(() => {
  //   const menu = rootGetters['menus/currentMenu']
  //   const pricePlan = rootGetters['menus/currentPricePlan']
  //   const city = rootState.cities.active
  //
  //   let price = rootGetters['menus/currentMenuPrice']
  //
  //   // пробуем продублировать тут данные товара, смотрим, что будет со статистикой проброса
  //   Vue.gtm.trackEvent({
  //     'event': 'add_to_cart',
  //     'product_price': price,
  //     'product_menu_type': menu.type,
  //     'product_meal_days': pricePlan.numberOfMealDays,
  //     'product_city_id': city.id
  //   })
  // }),
  // inputPhone: ({ rootState }, actionData) => new Promise(() => {
  //   // данные товара уже в dataLayer после productClick
  //   // в терминологии EEC это переход к шагу 1 чекаута
  //   // это событие тупо ввода телефона, без отправки
  //   Vue.gtm.trackEvent({
  //     'event': 'input_phone',
  //     'form_placement': actionData.formPlacement
  //     // 'order_id': rootState.orders.order.normal[0].id_H,
  //     // 'order_price': rootState.orders.order.normal[0].deb_price
  //   })
  //
  //   // window.VWO = window.VWO || []
  //   // window.VWO.push(['track.revenueConversion', rootState.orders.order.normal[0].deb_price])
  // }),
  // sendPhoneAsOrder: ({ rootState }, actionData) => new Promise(() => {
  //   // const menu = rootState.menus.currentMenu
  //   // const pricePlan = rootState.menus.currentPricePlan
  //   // const city = rootState.cities.active
  //   let data = {
  //     'event': 'go_to_step',
  //     'step_number': 2,
  //     'step_option': '',
  //     'form_placement': actionData.formPlacement
  //   }
  //   data.order_id = rootState.orders.order.normal[0].id_H
  //   data.user_id = rootState.client.profile.id_H
  //   data.order_price = rootState.orders.order.normal[0].deb_price
  //   data.external_interaction = rootState.client.profile.externalInteraction
  //   data.active_client_goal = rootState.client.profile.activeClientGoal
  //   let replaceAll = function (string, search, replace) {
  //     return string.split(search).join(replace)
  //   }
  //   let ph = replaceAll(actionData.phone, '+', '')
  //   ph = replaceAll(ph, '-', '')
  //   ph = replaceAll(ph, ' ', '')
  //   console.log(ph)
  //   data.phone_md5 = md5(ph)
  //
  //   // data.product_price = pricePlan.price
  //   // data.product_menu_type = menu.type
  //   // data.product_meal_days = pricePlan.numberOfMealDays
  //   // data.product_city_id = city.id
  //
  //   Vue.gtm.trackEvent(data)
  // }),
  // sendPhoneAsPseudoOrder: ({ rootState }, { stepOption, pseudoOrderId, pseudoOrderType, formPlacement }) => new Promise(() => {
  //   let data = {
  //     'event': 'go_to_step',
  //     'step_number': 2,
  //     'step_option': stepOption,
  //     'form_placement': formPlacement
  //   }
  //
  //   data.pseudo_order_id = pseudoOrderId
  //   data.pseudo_order_type = pseudoOrderType
  //
  //   Vue.gtm.trackEvent(data)
  // }),
  // goToStep: ({ rootState, rootGetters }, { stepNumber, stepOption, addProduct }) => new Promise(() => {
  //   let data = {
  //     'event': 'go_to_step',
  //     'step_number': stepNumber, // переход к шагу stepNumber
  //     'step_option': stepOption // значение checkout_option для шага (stepNumber - 1) (!!! минус 1 !!!
  //   }
  //
  //   // для всяких нестандартных флоу
  //   if (addProduct === undefined) {
  //     addProduct = false
  //   }
  //   if (addProduct) {
  //     const menu = rootGetters['menus/currentMenu']
  //     const pricePlan = rootGetters['menus/currentPricePlan']
  //     const city = rootState.cities.active
  //     data.product_price = pricePlan.price
  //     data.product_menu_type = menu.type
  //     data.product_meal_days = pricePlan.numberOfMealDays
  //     data.product_city_id = city.id
  //   }
  //
  //   Vue.gtm.trackEvent(data)
  // }),
  // createOrderFromAuthorized: ({ rootState, rootGetters }) => new Promise(() => {
  //   const menu = rootGetters['menus/currentMenu']
  //   const pricePlan = rootGetters['menus/currentPricePlan']
  //   const city = rootState.cities.active
  //
  //   Vue.gtm.trackEvent({
  //     'event': 'order_authorized',
  //     'product_price': pricePlan.price,
  //     'product_menu_type': menu.type,
  //     'product_meal_days': pricePlan.numberOfMealDays,
  //     'product_city_id': city.id,
  //     'order_id': rootState.orders.order.normal[0].id_H,
  //     'order_price': rootState.orders.order.normal[0].deb_price
  //   })
  // }),
  // // При рендере SelectMenuPlan
  // listMenuPlans: ({ rootState, rootGetters }) => new Promise(() => {
  //   const city = rootGetters['cities/active']
  //
  //   Vue.gtm.trackEvent({
  //     'event': 'products_list_initialize',
  //     'products_list': map(rootGetters['menus/sortedAndFilteredMenuTypes'], (type) => {
  //       let minMealDays = Object.keys(rootGetters['marketing/enabledMainOfferConfig'][type])[0]
  //       return rootGetters['enabledBusinessProduct'] + '-' + type + '-' + minMealDays + '-' + city.alias
  //     }, [])
  //   })
  // }),
  // // probably add some info here cuz it's not single event
  // openRecall: ({ rootState }) => new Promise(() => {
  //   Vue.gtm.trackEvent({
  //     'event': 'open_recall'
  //   })
  // }),
  // inputRecall: ({ rootState }) => new Promise(() => {
  //   Vue.gtm.trackEvent({
  //     'event': 'input_recall'
  //   })
  // }),
  // sendRecall: ({ rootState }, { pseudoOrderId }) => new Promise(() => {
  //   Vue.gtm.trackEvent({
  //     'event': 'send_recall',
  //     'pseudo_order_id': pseudoOrderId,
  //     'pseudo_order_type': 3
  //   })
  // }),
  // // probably add some info here cuz it's not single event
  // openHelp: ({ rootState }) => new Promise(() => {
  //   Vue.gtm.trackEvent({
  //     'event': 'open_help'
  //   })
  // }),
  // sendHelp: ({ rootState }) => new Promise(() => {
  //   Vue.gtm.trackEvent({
  //     'event': 'send_help'
  //   })
  // }),
  // changeUrl: ({ rootState }) => new Promise(() => {
  //   Vue.gtm.trackEvent({
  //     'event': 'change_url'
  //   })
  // }),
  singleEvent: function singleEvent(_ref, event) {
    var rootState = _ref.rootState;
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].gtm.trackEvent({
        'event': event
      });
    });
  },
  // applyPromo: ({ rootState }, data) => new Promise(() => {
  //   Vue.gtm.trackEvent({
  //     'event': data.withOrder ? 'apply-promo-with-order' : 'apply-promo',
  //     'applied_promo': data.promocode,
  //     'applied_discount': data.discount
  //   })
  // }),
  // pushValues: ({ rootState }, data) => new Promise(() => {
  //   let dataLayer = window.dataLayer || []
  //   dataLayer.push(data)
  // }),
  sendSimpleEvent: function sendSimpleEvent(_ref2, data) {
    var rootState = _ref2.rootState;
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
      // Vue.gtm.trackEvent({
      //   'event': 'standard-markup-event',
      //   'markup_block': data.block,
      //   'markup_element': data.element,
      //   'markup_action': data.action,
      //   'markup_action_details': data.details,
      //   'markup_action_value': data.value
      // })
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].gtm.trackEvent(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, { event: 'simple_event' }));
    });
  }
});

/***/ }),

/***/ 878:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
// import find from 'lodash/find'

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 879:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_store_types__ = __webpack_require__(50);





var state = {
  specificQueryParams: {}
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3__src_store_types__["a" /* default */].marketing.SET_SPECIFIC_QUERY_PARAMS_FULLY, function (state, params) {
  state.specificQueryParams = params;
});

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */]
});

/***/ }),

/***/ 880:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_reduce__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_merge__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_forEach__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_store_types__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_js_cookie__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(885);










/* harmony default export */ __webpack_exports__["a"] = ({
  processSpecificQueryParams: function processSpecificQueryParams(_ref) {
    var rootState = _ref.rootState,
        commit = _ref.commit;
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
      var paramsObj = {};
      var queryHasUtms = __WEBPACK_IMPORTED_MODULE_2_lodash_reduce___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* queryParamsRules */].utms), function (res, key) {
        return res || rootState.route.query[key];
      }, false);
      if (queryHasUtms) {
        __WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* queryParamsRules */].utms), function (key) {
          __WEBPACK_IMPORTED_MODULE_6_js_cookie___default.a.remove(key);
        });
      }
      __WEBPACK_IMPORTED_MODULE_4_lodash_forEach___default()(__WEBPACK_IMPORTED_MODULE_3_lodash_merge___default()(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* queryParamsRules */].other, __WEBPACK_IMPORTED_MODULE_7__config__["a" /* queryParamsRules */].utms), function (param, key) {
        if (__WEBPACK_IMPORTED_MODULE_6_js_cookie___default.a.get(key)) {
          paramsObj[key] = __WEBPACK_IMPORTED_MODULE_6_js_cookie___default.a.get(key);
        }
        if (rootState.route.query[key]) {
          __WEBPACK_IMPORTED_MODULE_6_js_cookie___default.a.set(key, rootState.route.query[key], {
            expires: param.days
          });

          paramsObj[key] = rootState.route.query[key];
        }
      });
      if (document.referrer && !document.referrer.includes(window.location.hostname)) {
        __WEBPACK_IMPORTED_MODULE_6_js_cookie___default.a.set('document_referrer', document.referrer, {
          expires: 30
        });
      }
      commit(__WEBPACK_IMPORTED_MODULE_5__src_store_types__["a" /* default */].marketing.SET_SPECIFIC_QUERY_PARAMS_FULLY, paramsObj);
      resolve();
    });
  }
});

/***/ }),

/***/ 885:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return queryParamsRules; });
var queryParamsRules = {
  'utms': {
    'utm_medium': {
      days: 30
    },
    'utm_source': {
      days: 30
    },
    'utm_campaign': {
      days: 30
    },
    'utm_content': {
      days: 30
    },
    'utm_term': {
      days: 30
    }
  },
  'other': {
    // 'autocoupon': {
    //   days: 1
    // },
    'document_referrer': { days: 30 // это фейк для реактивизации куки
    } }
};



/***/ }),

/***/ 886:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
// import { defaultRootConfigNode, processMainOfferDiscountConfig, calcComboDiscount } from './config'
// // import router from '/src/router'
// import DeviceDetector from '@/plugins/device-detector'
// import moment from 'moment'

/* harmony default export */ __webpack_exports__["a"] = ({
  specificQueryParams: function specificQueryParams(state) {
    return state.specificQueryParams;
  }
});

/***/ }),

/***/ 887:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_store_config__ = __webpack_require__(206);



var mixin = {
  data: function data() {
    return {};
  },

  computed: {
    isSmartphone: function isSmartphone() {
      return this.$root.rootIsSmartphone;
    },
    isWindows: function isWindows() {
      return this.$root.rootIsWindows;
    },
    isIOS: function isIOS() {
      return this.$root.rootIsIOS;
    },
    pageHasLeftBar: function pageHasLeftBar() {
      return Boolean(this.$route.meta.leftBarComponent) && !this.isSmartphone;
    }
  },
  filters: {
    money: function money(number) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__src_store_config__["b" /* moneyFormatFunc */])(number);
    }
  },
  methods: {
    numberLingForm: function numberLingForm(number, chelovek, cheloveka, chelovekov) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__src_store_config__["c" /* numberLingFormFunc */])(number, chelovek, cheloveka, chelovekov);
    },
    numberLingFormWithNumber: function numberLingFormWithNumber(number, chelovek, cheloveka, chelovekov) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__src_store_config__["d" /* numberLingFormWithNumberFunc */])(number, chelovek, cheloveka, chelovekov);
    },
    sendSimpleEvent: function sendSimpleEvent(data) {
      var _this = this;

      if (window.dataLayer && window.dataLayer.push || "production" === 'development') {
        this.$store.dispatch('gtm/sendSimpleEvent', data, { global: true });
      } else {
        this.$bus.$on('data.layer.ready', function () {
          _this.$store.dispatch('gtm/sendSimpleEvent', data, { global: true });
        });
      }
    },
    moneyFormat: function moneyFormat(number) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__src_store_config__["b" /* moneyFormatFunc */])(number);
    }
  }
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin({
  mixins: [mixin]
});

/***/ }),

/***/ 888:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_device_detector__ = __webpack_require__(889);


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      rootIsSmartphone: false,
      rootIsMobile: false,
      rootIsWindows: false,
      rootVueHeadViewport: false
    };
  },

  watch: {
    '$route': {
      handler: function handler() {
        document.title = this.$route.meta.title;
      },

      immediate: true
    }
  },
  computed: {},
  methods: {
    checkDevice: function checkDevice() {
      this.rootIsSmartphone = __WEBPACK_IMPORTED_MODULE_0__plugins_device_detector__["a" /* default */].isSmartphone;
      this.rootIsMobile = __WEBPACK_IMPORTED_MODULE_0__plugins_device_detector__["a" /* default */].isMobile;
      this.rootIsWindows = __WEBPACK_IMPORTED_MODULE_0__plugins_device_detector__["a" /* default */].isWindows;
      this.rootIsIOS = __WEBPACK_IMPORTED_MODULE_0__plugins_device_detector__["a" /* default */].isIOS;
      this.rootVueHeadViewport = this.rootIsSmartphone ? 'width=320,user-scalable=no,target-densitydpi=device-dpi' : 'width=device-width,initial-scale=1,maximum-scale=1,user-scalable=no,shrink-to-fit=no';
    }
  },
  head: {
    meta: function meta() {
      return [{ name: 'viewport', content: this.rootVueHeadViewport }];
    }
  },
  created: function created() {
    this.checkDevice();

    if (this.rootIsMobile) {
      document.documentElement.classList.add('touch');
    }
    // for scrollbar fix
    if (this.rootIsWindows) {
      document.documentElement.classList.add('win');
    }
    // for mobile version
    if (this.rootIsSmartphone) {
      document.documentElement.classList.add('smartphone');
    }
    // for mobile version
    if (this.rootIsIOS) {
      document.documentElement.classList.add('ios');
    }
  }
});

/***/ }),

/***/ 889:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
var detector = {
  isSmartphone: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(navigator.userAgent || navigator.vendor || window.opera) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test((navigator.userAgent || navigator.vendor || window.opera).substr(0, 4)),
  isMobile: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(navigator.userAgent || navigator.vendor || window.opera) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test((navigator.userAgent || navigator.vendor || window.opera).substr(0, 4)),
  isWindows: navigator.platform.indexOf('Win') > -1,
  isIOS: !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
};

/* harmony default export */ __webpack_exports__["a"] = (detector);

/***/ }),

/***/ 890:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

;
// import DeviceDetector from '@/plugins/device-detector'

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      attemptsLeft: 200,
      checkerInterval: null
    };
  },
  created: function created() {
    var _this = this;

    this.checkerInterval = setInterval(function () {
      if (window.dataLayer && window.dataLayer.push || "production" === 'development') {
        clearInterval(_this.checkerInterval);
        _this.$bus.$emit('data.layer.ready');
      } else {
        _this.attemptsLeft--;
      }

      if (_this.attemptsLeft === 0) {
        clearInterval(_this.checkerInterval);
      }
    }, 100);
  }
});

/***/ }),

/***/ 891:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[365]);


// WEBPACK FOOTER //
// static/js/output.88cb865d1fff179ac33e.bundle.js